// 中文语言包
export default {
  site: {
    title: '月升工具网 - 超实用在线查询工具',
    name: '月升工具网',
    slogan: '超实用在线查询工具，让工作生活更高效'
  },
  nav: {
    home: '首页',
    json: 'JSON格式化',
    timestamp: '时间戳转换',
    wordcount: '字数统计',
    calculator: '计算器',
    about: '关于我们',
    privacy: '隐私政策',
    blog: '技术博客'
  },
  theme: {
    light: '切换到明亮模式',
    dark: '切换到暗黑模式'
  },
  language: {
    switch: '切换语言',
    zh: '中文',
    en: 'English'
  },
  footer: {
    copyright: '© 2026 月升工具网 - 超实用查询工具'
  },
  donate: {
    button: '请作者喝杯咖啡',
    title: '请作者喝杯咖啡 ☕',
    subtitle: '如果这些工具对你有帮助，欢迎自愿打赏支持~',
    wechat: '微信',
    alipay: '支付宝',
    scanHint: '打开手机扫一扫，自愿打赏任意金额',
    thanks: '感谢你的支持，这是我持续更新的动力！❤️'
  },
  common: {
    copy: '复制',
    copyResult: '复制结果',
    clear: '清空',
    calculate: '计算',
    convert: '转换',
    copied: '已复制到剪贴板！',
    copyFailed: '复制失败，请手动复制',
    inputPlaceholder: '请输入...',
    resultPlaceholder: '结果将显示在这里...',
    error: '错误',
    success: '成功',
    loading: '加载中...',
    refresh: '刷新'
  },
  home: {
    welcome: '欢迎使用月升工具网',
    intro: '月升工具网是一个专注于提供免费、实用在线工具的网站。我们精心开发了多款实用工具，涵盖开发者工具、文本处理、图片处理和日常生活计算等多个领域。所有工具均可在线使用，无需下载安装任何软件，打开网页即可使用。',
    introDetail: '我们的工具完全免费，无需注册登录。更重要的是，您输入的所有数据都在浏览器本地处理，不会上传到服务器，充分保护您的隐私安全。无论您是程序员需要格式化 JSON 数据，还是普通用户需要计算房贷月供，月升工具网都能为您提供便捷的解决方案。',
    features: {
      free: '永久免费',
      secure: '隐私安全',
      instant: '即开即用',
      responsive: '多端适配'
    },
    sections: {
      devTools: '开发工具',
      devToolsDesc: '专为程序员和开发者设计的实用工具，帮助您更高效地处理日常开发工作中的各种数据格式转换和验证需求。',
      textTools: '文本处理',
      textToolsDesc: '提供多种文本处理和转换工具，满足您在写作、编辑和文档处理过程中的各种需求，让文字处理更加轻松高效。',
      imageTools: '图片处理',
      imageToolsDesc: '在线图片处理工具，无需安装专业软件，直接在浏览器中完成图片压缩、裁剪和滤镜效果处理。',
      lifeTools: '生活工具',
      lifeToolsDesc: '实用的日常生活计算工具，帮助您轻松完成房贷计算、个税计算、健康评估和货币换算等日常需求。',
      codecTools: '编解码工具',
      codecToolsDesc: '提供多种编码解码和加密哈希工具，满足开发调试、数据转换和安全生成等需求，所有操作均在浏览器本地完成。'
    },
    tools: {
      json: {
        title: 'JSON格式化',
        desc: '在线验证、格式化和压缩 JSON 数据，支持语法高亮显示，帮助开发者快速检查和美化 JSON 格式的数据。'
      },
      timestamp: {
        title: '时间戳转换',
        desc: 'Unix 时间戳与标准日期时间格式的在线互相转换工具，支持秒级和毫秒级时间戳，是开发调试的必备工具。'
      },
      calculator: {
        title: '计算器',
        desc: '功能强大的在线科学计算器，支持基础运算和高级数学函数计算，界面简洁，操作便捷。'
      },
      wordcount: {
        title: '字数统计',
        desc: '在线统计文章的字数、字符数、段落数和行数，支持中英文混合统计，是写作和编辑的得力助手。'
      },
      markdown: {
        title: 'Markdown编辑器',
        desc: '支持实时预览的在线 Markdown 编辑器，让您轻松编写格式优美的文档，支持常用的 Markdown 语法。'
      },
      traditional: {
        title: '繁体字转换',
        desc: '简体中文与繁体中文在线互相转换工具，支持批量转换，适用于两岸三地的文字交流需求。'
      },
      uppercase: {
        title: '大写金额转换',
        desc: '将阿拉伯数字金额转换为中文大写金额，符合财务规范要求，适用于支票、发票等正式场合。'
      },
      image: {
        title: '图片处理',
        desc: '在线图片压缩、裁剪和滤镜效果处理工具，支持 JPG、PNG 等常见格式，本地处理保护隐私。'
      },
      qrGenerator: {
        title: '二维码生成',
        desc: '在线生成二维码，支持自定义大小、颜色和纠错级别，可下载 PNG 和 SVG 格式。'
      },
      qrScanner: {
        title: '二维码解析',
        desc: '上传或拖拽图片识别二维码内容，支持粘贴截图，本地解析保护隐私。'
      },
      mortgage: {
        title: '房贷计算器',
        desc: '专业的房贷月供计算工具，支持等额本息和等额本金两种还款方式，详细展示每月还款明细和利息总额。'
      },
      tax: {
        title: '个税计算器',
        desc: '根据最新个人所得税法计算工资薪金所得税，支持专项附加扣除，让您清楚了解税后实际收入。'
      },
      bmi: {
        title: 'BMI计算器',
        desc: '身体质量指数（BMI）在线计算工具，根据身高体重评估健康状况，提供科学的体重管理建议。'
      },
      exchange: {
        title: '汇率计算',
        desc: '多币种实时汇率换算工具，支持美元、欧元、日元、港币等主流货币，汇率数据实时更新。'
      },
      taxRate: {
        title: '税率计算器',
        desc: '根据金额和税率快速计算税金，支持含税/不含税金额互算，覆盖常见增值税税率。'
      },
      listSum: {
        title: '列表求和',
        desc: '对一组数字快速求和，同时计算平均值、最大最小值和中位数，支持多种分隔符。'
      },
      loanCalc: {
        title: '贷款计算器',
        desc: '通用贷款月供计算，支持等额本息和等额本金两种方式，详细展示每月还款明细。'
      },
      textDedup: {
        title: '文本去重',
        desc: '快速去除文本中的重复行，支持忽略大小写和空行过滤，适用于数据清洗和列表整理。'
      },
      textReplace: {
        title: '文本替换',
        desc: '强大的在线文本查找替换工具，支持普通文本和正则表达式匹配，批量替换更高效。'
      },
      textSort: {
        title: '文本排序',
        desc: '对文本按行进行升序、降序排列或随机打乱，支持中文拼音排序和数字排序。'
      },
      textNumber: {
        title: '文本加序号',
        desc: '为文本的每一行自动添加序号编号，支持多种序号格式和自定义起始数字。'
      },
      text2html: {
        title: '文本转HTML',
        desc: '将纯文本转换为HTML格式，支持段落、列表、换行和表格等多种转换模式。'
      },
      wordFreq: {
        title: '词频统计',
        desc: '分析文本中词语出现的频率，支持中英文分词统计，可视化展示词频排行。'
      },
      namingConverter: {
        title: '命名转换器',
        desc: '在 camelCase、PascalCase、snake_case、kebab-case 等编程命名规范之间快速转换。'
      },
      regexTester: {
        title: '正则测试',
        desc: '在线测试和调试正则表达式，实时高亮显示匹配结果，支持分组捕获查看。'
      },
      colorConverter: {
        title: '颜色转换',
        desc: '在 HEX、RGB、RGBA、HSL 等颜色格式之间互转，带实时颜色预览和取色器。'
      },
      codeFormatter: {
        title: '代码格式化',
        desc: '支持 CSS、JavaScript、HTML、SQL 代码的在线格式化（美化）和压缩（最小化）。'
      },
      crontab: {
        title: 'Crontab计算',
        desc: '解析 Crontab 定时任务表达式，预览未来执行时间，提供常用表达式预设。'
      },
      base64: {
        title: 'Base64编解码',
        desc: '在线 Base64 编码与解码工具，支持中文和特殊字符，一键完成文本的 Base64 转换。'
      },
      urlCodec: {
        title: 'URL编解码',
        desc: '在线 URL 编码与解码工具，支持 encodeURI 和 encodeURIComponent 两种模式。'
      },
      hashTool: {
        title: 'MD5/SHA哈希',
        desc: '在线计算文本的 MD5、SHA-1、SHA-256、SHA-512 等哈希值，支持大小写切换。'
      },
      unicodeConverter: {
        title: 'Unicode转换',
        desc: '在 Unicode、十六进制、HTML实体和 UTF-8 编码之间互相转换，支持中英文字符。'
      },
      morseCode: {
        title: '摩斯电码',
        desc: '文本与摩斯电码在线互转，支持音频播放摩斯电码，内置完整字符对照表。'
      },
      passwordGen: {
        title: '随机密码生成',
        desc: '生成安全随机密码，支持自定义长度、字符类型，密码强度实时评估，支持批量生成。'
      },
      uuidGen: {
        title: 'UUID生成器',
        desc: '在线生成 UUID/GUID，支持 v1（时间戳）和 v4（随机）版本，批量生成和多种格式选项。'
      }
    },
    usage: {
      title: '如何使用月升工具网',
      step1: {
        title: '选择工具',
        desc: '在首页浏览我们提供的各类工具，点击您需要使用的工具卡片进入对应功能页面。'
      },
      step2: {
        title: '输入数据',
        desc: '在工具页面输入您需要处理的数据，所有数据处理都在您的浏览器本地完成，确保隐私安全。'
      },
      step3: {
        title: '获取结果',
        desc: '工具会即时显示处理结果，您可以复制结果或继续进行其他操作，简单高效。'
      }
    },
    faq: {
      title: '常见问题',
      q1: {
        question: '月升工具网是免费的吗？',
        answer: '是的，月升工具网提供的所有工具都是完全免费的，您可以无限制地使用任何功能，无需注册或登录账号。'
      },
      q2: {
        question: '我的数据安全吗？',
        answer: '非常安全。我们所有的工具都在您的浏览器本地运行，您输入的数据不会被上传到任何服务器。您的隐私由您自己完全掌控。'
      },
      q3: {
        question: '可以在手机上使用吗？',
        answer: '当然可以。月升工具网采用响应式设计，完美适配电脑、平板和手机等各种设备，随时随地都能使用。'
      },
      q4: {
        question: '工具会持续更新吗？',
        answer: '是的，我们会根据用户需求持续开发新的实用工具，并不断优化现有工具的功能和体验。欢迎向我们提出建议。'
      }
    }
  },
  json: {
    title: 'JSON格式化工具',
    subtitle: '在线验证、格式化和压缩 JSON 数据，支持语法高亮显示，是程序员开发调试的必备工具',
    format: '格式化',
    compress: '压缩',
    inputLabel: '输入 JSON',
    outputLabel: '输出结果',
    inputPlaceholder: '请输入或粘贴JSON数据...',
    outputPlaceholder: '格式化后的结果将显示在这里...',
    indentSpaces: '缩进空格数',
    formatSuccess: 'JSON格式化成功！',
    compressSuccess: 'JSON压缩成功！',
    emptyError: '请输入JSON数据',
    formatError: 'JSON格式错误',
    whatIsJson: '什么是 JSON？',
    whatIsJsonDesc: 'JSON（JavaScript Object Notation，JavaScript 对象表示法）是一种轻量级的数据交换格式，由道格拉斯·克罗克福特（Douglas Crockford）在 2001 年首次提出。JSON 基于 JavaScript 语言的一个子集，但它是独立于语言的文本格式，几乎所有现代编程语言都支持 JSON 的解析和生成。JSON 已经成为互联网上最常用的数据格式之一，在 Web API、配置文件、数据存储、前后端通信等场景中广泛应用。',
    features: 'JSON 格式化工具的功能',
    featureFormat: '格式化（美化）：将压缩的 JSON 数据转换为带缩进的、易于阅读的格式，方便查看数据结构和调试程序。',
    featureCompress: '压缩（最小化）：移除 JSON 中的空格和换行符，减小数据体积，适合网络传输和存储。',
    featureValidate: '语法验证：自动检测 JSON 格式是否正确，帮助您快速发现语法错误。',
    featureCopy: '一键复制：处理完成后可以一键复制结果，方便在其他地方使用。',
    howToUse: '如何使用本工具',
    howToUseSteps: [
      '在左侧文本框中粘贴或输入您的 JSON 数据。',
      '点击"格式化"按钮美化 JSON，或点击"压缩"按钮最小化 JSON。',
      '如果 JSON 格式有误，工具会显示具体的错误信息。',
      '处理成功后，结果会显示在右侧文本框中，点击"复制结果"即可复制。'
    ],
    example: 'JSON 格式示例',
    exampleDesc: '一个标准的 JSON 对象示例：',
    commonErrors: '常见 JSON 错误',
    errorQuotes: '缺少引号：JSON 的键名必须用双引号包围，单引号或不加引号都是错误的。',
    errorTrailingComma: '末尾多余逗号：数组或对象的最后一个元素后面不能有逗号。',
    errorSingleQuote: '使用单引号：JSON 只支持双引号，不支持单引号。',
    errorComments: '注释：标准 JSON 不支持注释，添加注释会导致解析失败。',
    jsonHistory: 'JSON 的发展历史',
    jsonHistoryDesc: 'JSON 格式诞生于 2001 年，最初是作为 XML 的轻量级替代方案而设计的。2006 年，JSON 被正式定义为 RFC 4627 标准。2013 年，ECMA-404 标准发布，进一步规范了 JSON 的语法。如今，JSON 已经完全取代 XML 成为 Web 开发中最主流的数据交换格式。',
    jsonVsXml: 'JSON 与 XML 的对比',
    jsonVsXmlItems: [
      '体积更小：相同数据下，JSON 格式通常比 XML 小 30%-50%，节省网络带宽。',
      '解析更快：JSON 可以直接被 JavaScript 解析，无需额外的解析器，处理速度更快。',
      '更易读写：JSON 语法简洁直观，人类可以轻松阅读和手写 JSON 数据。',
      '原生支持：现代浏览器和编程语言都内置了 JSON 解析功能，无需额外依赖。'
    ],
    jsonDataTypes: 'JSON 支持的数据类型',
    jsonDataTypesItems: [
      '字符串（String）：用双引号包围的文本，如 "hello world"',
      '数字（Number）：整数或浮点数，如 42、3.14、-100',
      '布尔值（Boolean）：true 或 false',
      '空值（Null）：null 表示空或无值',
      '数组（Array）：用方括号包围的有序值列表，如 [1, 2, 3]',
      '对象（Object）：用花括号包围的键值对集合，如 {"name": "张三"}'
    ],
    jsonUseCases: 'JSON 的常见应用场景',
    jsonUseCasesItems: [
      'Web API 数据传输：RESTful API 几乎都使用 JSON 作为数据格式',
      '配置文件：package.json、tsconfig.json 等项目配置文件',
      '数据存储：MongoDB 等 NoSQL 数据库使用 JSON 格式存储数据',
      '前后端通信：Ajax 请求通常使用 JSON 传递数据',
      '日志记录：结构化日志常采用 JSON 格式便于分析',
      '消息队列：Kafka、RabbitMQ 等消息中间件常用 JSON 格式传递消息'
    ],
    jsonBestPractices: 'JSON 使用最佳实践',
    jsonBestPracticesItems: [
      '使用有意义的键名：键名应该清晰表达数据含义，如用 "userName" 而非 "u"',
      '保持数据结构一致：同类型数据应保持相同的结构，便于解析处理',
      '避免深层嵌套：过深的嵌套会增加解析复杂度，建议不超过 4-5 层',
      '使用数组存储列表：同类型的多个元素应使用数组而非编号键',
      '日期使用 ISO 8601 格式：如 "2024-01-15T10:30:00Z"，便于跨平台解析'
    ]
  },
  timestamp: {
    title: '时间戳转换工具',
    subtitle: 'Unix 时间戳与标准日期时间格式的在线互相转换，支持秒级和毫秒级时间戳',
    currentTimestamp: '当前时间戳',
    toDate: '时间戳 → 日期时间',
    toTimestamp: '日期时间 → 时间戳',
    inputPlaceholder: '输入时间戳（秒或毫秒）',
    seconds: '秒 (s)',
    milliseconds: '毫秒 (ms)',
    localTime: '本地时间',
    utcTime: 'UTC时间',
    isoFormat: 'ISO格式',
    secondsTimestamp: '秒级时间戳',
    millisecondsTimestamp: '毫秒级时间戳',
    currentTime: '当前时间',
    invalidNumber: '请输入有效的数字',
    invalidTimestamp: '无效的时间戳',
    conversionFailed: '转换失败',
    whatIsTimestamp: '什么是 Unix 时间戳？',
    whatIsTimestampDesc: 'Unix 时间戳（Unix Timestamp），也叫 POSIX 时间或 Epoch 时间，是一种时间表示方式。它定义为从 1970 年 1 月 1 日 00:00:00 UTC（协调世界时）到现在所经过的总秒数，不考虑闰秒。这个起始时间点被称为「Unix 纪元」（Unix Epoch）。由于时间戳是一个简单的整数，不依赖于时区，因此在不同系统、不同地区之间传递时间信息时非常方便和可靠。',
    useCases: '时间戳的应用场景',
    useCaseDb: '数据库存储：很多数据库使用时间戳来存储时间信息，因为整数比日期字符串更节省空间，查询效率也更高。',
    useCaseApi: 'API 接口：Web API 通常使用时间戳来传递时间参数，避免时区转换带来的问题。',
    useCaseLog: '日志记录：系统日志常用时间戳记录事件发生的精确时间。',
    useCaseCache: '缓存控制：浏览器和服务器使用时间戳来判断缓存是否过期。',
    comparison: '秒级时间戳 vs 毫秒级时间戳',
    comparisonDesc: '时间戳有两种常见的精度：',
    comparisonSeconds: '秒级时间戳（10 位）：例如 1707235200，精确到秒，常用于 Unix/Linux 系统和大多数后端编程语言。',
    comparisonMilliseconds: '毫秒级时间戳（13 位）：例如 1707235200000，精确到毫秒，常用于 JavaScript 和需要更高精度的场景。',
    programmingExamples: '常见编程语言获取时间戳',
    timestampHistory: '时间戳的由来',
    timestampHistoryDesc: '1970 年 1 月 1 日被选为 Unix 纪元的起点，主要是因为 Unix 操作系统最初是在 1969-1970 年间由贝尔实验室的肯·汤普森（Ken Thompson）和丹尼斯·里奇（Dennis Ritchie）开发的。当时选择一个「最近的」、「容易记忆的」时间点作为起点。这个设计决定一直沿用至今，成为计算机领域的标准。',
    y2038Problem: '2038 年问题',
    y2038ProblemDesc: '32 位系统存储的时间戳最大值为 2147483647（2^31-1），对应的时间是 2038 年 1 月 19 日 03:14:07 UTC。届时 32 位系统的时间戳将溢出，类似于「千年虫」问题。好消息是，大多数现代系统已经使用 64 位整数存储时间戳，可以表示到约 2920 亿年后的时间。',
    timezoneExplain: '时区与时间戳',
    timezoneExplainDesc: '时间戳的一大优势是它与时区无关。无论你在北京、纽约还是伦敦，同一时刻的时间戳都是相同的。在显示时间时，应用程序会根据用户所在时区将时间戳转换为本地时间。这就是为什么在跨时区协作时，使用时间戳可以避免很多困惑。',
    commonTimestamps: '常见特殊时间戳',
    commonTimestampsItems: [
      '0：1970-01-01 00:00:00 UTC（Unix 纪元）',
      '1000000000：2001-09-09 01:46:40 UTC（10 亿秒）',
      '1234567890：2009-02-13 23:31:30 UTC（著名的「1234567890」时刻）',
      '2147483647：2038-01-19 03:14:07 UTC（32 位系统最大值）'
    ],
    timestampTips: '使用时间戳的技巧',
    timestampTipsItems: [
      '存储时使用 UTC 时间戳，显示时转换为本地时间',
      '对于需要高精度的场景（如金融交易），使用毫秒级甚至微秒级时间戳',
      '在数据库中为时间戳字段建立索引，可大幅提升时间范围查询的性能',
      '注意前后端时间戳精度的统一，JavaScript 使用毫秒，部分后端语言使用秒'
    ]
  },
  wordcount: {
    title: '字数统计',
    subtitle: '统计文本的字符数、字数、行数等详细信息',
    totalChars: '总字符数',
    charsNoSpace: '字符(不含空格)',
    chineseChars: '中文字符',
    englishChars: '英文字母',
    englishWords: '英文单词',
    numbers: '数字',
    lines: '行数',
    paragraphs: '段落数',
    inputLabel: '输入文本',
    inputPlaceholder: '在此输入或粘贴文本，实时统计字数...',
    tip: '提示：支持中英文混合统计，中文按字符计算，英文按单词计算',
    // 新增原创内容
    whyWordCount: '为什么需要字数统计？',
    whyWordCountDesc: '字数统计是写作和内容创作中非常重要的功能。无论是学生写论文、作家写小说、编辑审稿、还是新媒体运营写推文，都需要关注字数。不同场景对字数有不同的要求，精确的字数统计可以帮助你更好地控制内容长度。',
    wordCountUseCases: '字数统计的应用场景',
    wordCountUseCasesItems: [
      '学术论文：毕业论文、期刊论文通常有严格的字数要求',
      '新媒体运营：微信公众号、微博等平台对标题和正文有字数限制',
      '翻译工作：翻译计费通常按字数或单词数计算',
      'SEO优化：搜索引擎对文章长度有一定偏好，太短或太长都不利于排名',
      '出版编辑：书籍编辑需要控制章节和全书字数'
    ],
    countingRules: '中英文字数统计规则',
    countingRulesDesc: '中文和英文的统计规则有所不同：',
    countingRulesItems: [
      '中文：通常按字符计算，一个汉字算一个字',
      '英文：通常按单词计算，以空格分隔',
      '混合文本：中文按字符、英文按单词分别统计',
      '标点符号：根据需求可计入或不计入字数'
    ],
    writingTips: '写作字数建议',
    writingTipsItems: [
      '微信公众号文章：建议 1500-3000 字，便于读者阅读',
      '知乎回答：优质回答通常在 500-2000 字',
      '博客文章：SEO 友好的文章建议 1000-2500 字',
      '新闻稿：通常 300-800 字，简洁明了',
      '产品说明：根据复杂度，500-1500 字为宜'
    ],
    platformLimits: '各平台字数限制速查',
    platformLimitsItems: [
      '微信公众号：标题最多 64 字，正文无上限但建议不超过 5000 字',
      '微博：正文最多 2000 字，转发评论最多 140 字',
      '小红书笔记：标题最多 20 字，正文最多 1000 字',
      '抖音标题：最多 55 字，建议控制在 30 字以内',
      '知乎回答：无字数限制，但超过 300 字的回答更容易获得推荐',
      '豆瓣短评：最多 350 字；影评无字数限制'
    ],
    readingTime: '阅读时间估算',
    readingTimeDesc: '了解阅读时间可以帮助你更好地规划文章长度。研究表明，中文阅读速度约为每分钟 300-500 字，英文阅读速度约为每分钟 200-300 词。也就是说，一篇 1500 字的中文文章大约需要 3-5 分钟阅读。互联网用户的平均注意力持续时间约为 8 秒，因此文章的开头部分尤为重要，需要在前 100 字内吸引读者继续阅读。',
    seoWordCount: '字数与 SEO 的关系',
    seoWordCountDesc: '搜索引擎优化（SEO）与文章字数有密切关系。研究数据显示，排名靠前的网页平均内容长度在 1500-2500 字之间。但字数并非越多越好，关键是内容的质量和相关性。Google 等搜索引擎更看重内容是否全面回答了用户的搜索问题，而不是简单地堆砌字数。高质量的 1000 字文章往往比低质量的 3000 字文章排名更好。',
    writingEfficiency: '提高写作效率的方法',
    writingEfficiencyItems: [
      '先列提纲：在写作前列出文章大纲，明确每个部分的要点和预计字数',
      '番茄工作法：每 25 分钟专注写作，休息 5 分钟，保持高效产出',
      '分段写作：将长文章拆分为多个独立段落，逐个完成',
      '先写后改：初稿阶段不要纠结用词，完成全文后再统一修改润色',
      '利用工具：使用字数统计工具实时监控进度，确保达到目标字数'
    ]
  },
  calculator: {
    title: '计算器',
    subtitle: '支持基础运算和科学计算的在线计算器',
    basic: '基础',
    scientific: '科学',
    history: '历史记录',
    clearHistory: '清空',
    // 新增原创内容
    whatIsCalculator: '在线计算器简介',
    whatIsCalculatorDesc: '本工具是一款功能强大的在线计算器，支持基础四则运算和科学计算功能。无需安装任何软件，打开网页即可使用。界面简洁直观，操作方便，适合日常计算、学习和工作使用。',
    basicFunctions: '基础计算功能',
    basicFunctionsItems: [
      '加法（+）：计算两个或多个数的和',
      '减法（-）：计算两个数的差',
      '乘法（×）：计算两个或多个数的积',
      '除法（÷）：计算两个数的商',
      '百分比（%）：计算百分比值'
    ],
    scientificFunctions: '科学计算功能',
    scientificFunctionsItems: [
      '三角函数：sin、cos、tan 及其反函数',
      '对数函数：log（常用对数）、ln（自然对数）',
      '指数运算：幂运算、平方根、立方根',
      '常数：π（圆周率）、e（自然常数）',
      '阶乘：n! 计算'
    ],
    calculatorTips: '使用技巧',
    calculatorTipsItems: [
      '可以使用键盘输入数字和运算符，提高输入效率',
      '支持括号运算，复杂表达式会按正确的优先级计算',
      '历史记录功能可以查看和复用之前的计算结果',
      '科学模式下三角函数默认使用弧度制'
    ],
    calculatorHistory: '计算器的发展历史',
    calculatorHistoryDesc: '人类最早的计算工具是算盘，起源于中国，距今已有数千年历史。17 世纪，法国数学家帕斯卡发明了第一台机械计算器。1946 年，第一台通用电子计算机 ENIAC 诞生。1972 年，惠普推出了第一台科学计算器 HP-35。随着互联网技术的发展，在线计算器成为日常生活中不可或缺的工具，无需携带设备，随时随地即可使用。',
    operationPriority: '运算优先级规则',
    operationPriorityDesc: '在数学运算中，运算符有不同的优先级。掌握优先级规则可以避免计算错误：',
    operationPriorityItems: [
      '括号优先：括号内的运算最先执行，嵌套括号从内到外依次计算',
      '幂运算次之：指数运算（如 2^3）优先于乘除法',
      '先乘除后加减：乘法和除法优先于加法和减法',
      '同级从左到右：同一优先级的运算符按从左到右的顺序依次执行',
      '特殊函数优先：三角函数、对数等函数内部的表达式最先计算'
    ],
    dailyCalculation: '日常生活中的实用计算',
    dailyCalculationItems: [
      '折扣计算：原价 × 折扣率 = 折后价格。例如 200 元打 8 折：200 × 0.8 = 160 元',
      '利息计算：本金 × 年利率 × 年数 = 利息收入。例如 10 万存 1 年利率 2%：100000 × 0.02 = 2000 元',
      '面积计算：长 × 宽 = 矩形面积，π × r² = 圆面积。例如 5m × 3m 的房间面积为 15 m²',
      '单位换算：1 英寸 = 2.54 厘米，1 英里 = 1.609 千米，1 磅 = 0.454 千克',
      '温度换算：°F = °C × 9/5 + 32，例如 37°C = 98.6°F'
    ],
    keyboardShortcuts: '键盘快捷操作',
    keyboardShortcutsItems: [
      '数字键 0-9：直接输入对应数字',
      '运算符键 +、-、*、/：输入对应运算符',
      'Enter 或 = 键：执行计算',
      'Backspace 键：删除最后一位输入',
      'Escape 键：清除所有输入（AC）'
    ]
  },
  mortgage: {
    title: '房贷计算器',
    subtitle: '专业的房贷月供计算工具，支持等额本息和等额本金两种还款方式，详细展示还款明细',
    loanAmount: '贷款总额',
    loanYears: '贷款期限',
    interestRate: '年利率',
    paymentMethod: '还款方式',
    equalPayment: '等额本息',
    equalPrincipal: '等额本金',
    calculate: '开始计算',
    results: '计算结果',
    monthlyPayment: '每月还款',
    firstMonthPayment: '首月还款',
    totalLoan: '贷款总额',
    totalInterest: '支付利息',
    totalPayment: '还款总额',
    details: '还款明细（前12期）',
    period: '期数',
    payment: '月供(元)',
    principal: '本金(元)',
    interest: '利息(元)',
    remaining: '剩余本金(元)',
    unit: {
      tenThousand: '万元',
      year: '年',
      percent: '%'
    },
    quickYears: '{n}年',
    housingFund: '公积金',
    commercial: '商贷',
    // 新增原创内容
    whatIsMortgage: '什么是房贷？',
    whatIsMortgageDesc: '房贷（住房贷款）是指银行或金融机构向购房者提供的、以所购房产作为抵押的贷款。购房者需要按照约定的期限和利率，分期偿还贷款本金和利息。房贷是大多数家庭购置房产的主要融资方式，了解房贷计算方法对于合理规划家庭财务至关重要。',
    repaymentMethods: '两种还款方式详解',
    equalPaymentExplain: '等额本息还款',
    equalPaymentExplainDesc: '等额本息是指每月还款金额固定不变的还款方式。前期还款中利息占比较大，本金占比较小；随着时间推移，利息逐渐减少，本金逐渐增加。这种方式适合收入稳定、希望每月还款额固定的购房者，便于家庭资金规划。',
    equalPrincipalExplain: '等额本金还款',
    equalPrincipalExplainDesc: '等额本金是指每月偿还的本金固定，利息随剩余本金减少而递减的还款方式。因此月还款额逐月递减，前期还款压力较大。这种方式总利息支出较少，适合前期还款能力较强、希望减少总利息支出的购房者。',
    comparisonTitle: '两种还款方式对比',
    comparisonItems: [
      '总利息：等额本金的总利息通常比等额本息少 10%-15%',
      '月供压力：等额本息每月固定，等额本金前期高后期低',
      '适合人群：收入稳定选等额本息，收入递减或想少付利息选等额本金',
      '提前还款：计划提前还款的，等额本金更划算'
    ],
    interestRateTypes: '贷款利率类型',
    interestRateTypesDesc: '中国目前主要有两种房贷利率：公积金贷款利率和商业贷款利率。公积金贷款利率较低（目前约 3.1%），但额度有限；商业贷款利率较高（目前 LPR 基准约 3.45%-4.2%），但额度充足。很多购房者会选择组合贷款，即同时使用公积金贷款和商业贷款。',
    prepaymentStrategies: '提前还款策略',
    prepaymentStrategiesItems: [
      '缩短期限 vs 减少月供：缩短期限节省的利息更多，减少月供可降低还款压力',
      '最佳时机：贷款前 1/3 期间提前还款效果最好，因为前期利息占比高',
      '违约金：部分银行对提前还款收取违约金，还款前需了解银行政策',
      '资金用途权衡：如果投资收益能稳定超过贷款利率，不一定要提前还款'
    ],
    buyingTips: '购房贷款建议',
    buyingTipsItems: [
      '月供不超过家庭月收入的 30%-40%，保留足够的生活资金',
      '首付尽量多付，可以减少贷款本金和总利息支出',
      '选择贷款期限要综合考虑年龄、收入增长预期和退休计划',
      '关注 LPR 利率变动，选择合适的利率重定价日',
      '购房前查询个人征信报告，良好的信用记录有助于获得更优惠的利率'
    ],
    lprExplain: 'LPR 利率说明',
    lprExplainDesc: 'LPR（贷款市场报价利率）是中国人民银行授权的报价利率，每月 20 日公布。房贷利率 = LPR + 银行加点。目前 5 年期以上 LPR 为 3.45%（2024年数据，仅供参考）。利率重定价日通常为每年 1 月 1 日或贷款发放日。'
  },
  tax: {
    title: '个税计算器',
    subtitle: '计算工资薪金个人所得税（2024年最新税率）',
    grossSalary: '税前月薪',
    insurance: '五险一金',
    insuranceTip: '包括养老、医疗、失业保险和住房公积金个人缴纳部分',
    specialDeduction: '专项附加扣除',
    calculate: '计算个税',
    results: '计算结果',
    taxPayable: '应缴个税',
    netSalary: '税后工资',
    details: '计算明细',
    threshold: '起征点',
    taxableIncome: '应纳税所得额',
    taxRate: '适用税率',
    quickDeduction: '速算扣除数',
    taxTable: '个人所得税税率表（综合所得适用）',
    level: '级数',
    taxableRange: '应纳税所得额',
    deductions: {
      children: '子女教育 2000元/月',
      education: '继续教育 400元/月',
      medical: '大病医疗（按实际）',
      housing: '住房贷款利息 1000元/月',
      rent: '住房租金 1500元/月',
      elderly: '赡养老人 3000元/月',
      baby: '3岁以下婴幼儿 2000元/月'
    },
    unit: '元',
    // 新增原创内容
    whatIsTax: '什么是个人所得税？',
    whatIsTaxDesc: '个人所得税是对个人（自然人）取得的各项应税所得征收的一种税。在中国，工资、薪金所得是最常见的应税项目。2019 年 1 月 1 日起，中国实施新个人所得税法，将起征点从 3500 元提高到 5000 元，并引入了专项附加扣除制度，让纳税更加公平合理。',
    taxFormula: '个税计算公式',
    taxFormulaDesc: '应纳税额 = 应纳税所得额 × 适用税率 - 速算扣除数。其中，应纳税所得额 = 税前收入 - 五险一金 - 起征点（5000元）- 专项附加扣除。',
    specialDeductionsExplain: '专项附加扣除详解',
    specialDeductionsItems: [
      '子女教育：每个子女每月 2000 元，从满 3 周岁至博士毕业，可夫妻双方各扣 50% 或一方扣 100%',
      '继续教育：学历教育每月 400 元（最长 48 个月），职业资格取证当年一次性扣除 3600 元',
      '大病医疗：医保目录范围内个人负担超过 15000 元的部分，据实扣除，每年最高 80000 元',
      '住房贷款利息：首套房贷款利息每月 1000 元，最长 240 个月（20 年）',
      '住房租金：根据城市规模不同，每月 800/1100/1500 元',
      '赡养老人：独生子女每月 3000 元，非独生子女分摊（每人最高 1500 元）',
      '3岁以下婴幼儿照护：每个婴幼儿每月 2000 元'
    ],
    taxRateLevels: '七级超额累进税率',
    taxRateLevelsDesc: '中国个人所得税采用七级超额累进税率，税率从 3% 到 45%。「超额累进」意味着只对超过该档次起点的部分按该档税率计税，而非全部收入都按最高档税率计算。这种设计使得收入越高，税率越高，体现了税收的公平性。',
    yearEndBonus: '年终奖计税方式',
    yearEndBonusDesc: '年终奖可以选择单独计税或并入综合所得计税。单独计税时，将年终奖除以 12，按月度税率表确定适用税率。2024 年起，年终奖单独计税政策继续执行，纳税人可以选择对自己更有利的方式。通常情况下，年收入较低时并入综合所得更划算，年收入较高时单独计税更划算。',
    taxPlanningTips: '合理税务规划建议',
    taxPlanningTipsItems: [
      '充分利用专项附加扣除，保留好相关凭证以备核查',
      '合理安排年终奖发放时间和金额，避免「多发一元多交税」的临界点',
      '配偶双方可以协商专项附加扣除的分配比例，选择对家庭整体最优的方案',
      '关注个税 APP 中的退税功能，每年 3-6 月可以办理上年度汇算清缴',
      '企业年金、商业健康保险等也可以抵扣个税，可向公司 HR 咨询'
    ],
    annualSettlement: '年度汇算清缴',
    annualSettlementDesc: '每年 3 月 1 日至 6 月 30 日，纳税人需要对上一年度的综合所得进行汇算清缴。如果预缴税额大于应纳税额，可以申请退税；如果预缴税额小于应纳税额，需要补缴税款。可通过「个人所得税」APP 或网页端完成年度汇算。'
  },
  bmi: {
    title: 'BMI计算器',
    subtitle: '计算身体质量指数，评估健康状况',
    height: '身高',
    weight: '体重',
    heightUnit: '厘米 (cm)',
    weightUnit: '公斤 (kg)',
    calculate: '计算BMI',
    bmiIndex: 'BMI指数',
    underweight: '偏瘦',
    normal: '正常',
    overweight: '偏胖',
    obese: '肥胖',
    healthyRange: '健康体重范围',
    idealWeight: '理想体重',
    suggestion: '体重建议',
    keepWeight: '保持当前体重',
    loseWeight: '建议减重 {n} kg',
    gainWeight: '建议增重 {n} kg',
    standardTable: 'BMI标准参考表（中国标准）',
    category: '分类',
    bmiRange: 'BMI范围',
    healthRisk: '健康风险',
    malnutritionRisk: '营养不良风险',
    healthyWeight: '健康体重',
    increased: '增加',
    highRisk: '高风险',
    // 新增原创内容
    whatIsBmi: '什么是 BMI？',
    whatIsBmiDesc: 'BMI（Body Mass Index，身体质量指数）是比利时统计学家阿道夫·凯特勒（Adolphe Quetelet）在 1832 年提出的一个用于评估人体胖瘦程度的指标。BMI = 体重(kg) ÷ 身高(m)²。虽然 BMI 不能直接测量体脂肪，但因为计算简单、易于普及，成为国际上最常用的衡量体重是否健康的指标。',
    bmiLimitations: 'BMI 的局限性',
    bmiLimitationsItems: [
      '不区分脂肪和肌肉：健身运动员可能 BMI 偏高但实际很健康',
      '不考虑脂肪分布：腹部脂肪（内脏脂肪）对健康危害更大',
      '不适用于特殊人群：孕妇、老年人、儿童需要使用不同的评估标准',
      '种族差异：亚洲人在相同 BMI 下体脂率可能更高，因此中国标准比 WHO 标准更严格'
    ],
    bmiStandards: 'BMI 标准对比',
    bmiStandardsDesc: 'WHO（世界卫生组织）标准：正常范围 18.5-24.9。中国标准更加严格：正常范围 18.5-23.9。这是因为研究表明，亚洲人在较低 BMI 时就可能面临健康风险。建议中国人按中国标准评估。',
    otherIndicators: '其他健康指标',
    otherIndicatorsItems: [
      '腰围：男性 < 90cm，女性 < 85cm 为正常（中国标准）',
      '腰臀比（WHR）：男性 < 0.9，女性 < 0.85 为正常',
      '体脂率：男性 15-20%，女性 20-25% 为理想范围',
      '内脏脂肪等级：1-9 为正常，10-14 偏高，15 以上危险'
    ],
    healthyWeightTips: '健康体重管理建议',
    healthyWeightTipsItems: [
      '每周减重不超过 0.5-1 kg，过快减重容易反弹',
      '结合有氧运动和力量训练，增加肌肉量提高基础代谢',
      '控制总热量摄入，但不要过度节食导致营养不良',
      '保证充足睡眠，睡眠不足会影响代谢和食欲调节',
      '定期监测体重变化，保持长期健康的生活方式'
    ],
    idealWeightFormulas: '理想体重计算公式',
    idealWeightFormulasDesc: '除了 BMI，还有多种理想体重计算方法：',
    idealWeightFormulasItems: [
      '简易公式：男性 = 身高(cm) - 105，女性 = 身高(cm) - 110',
      'Broca 公式：理想体重(kg) = 身高(cm) - 100',
      'BMI 反推：理想体重 = 21.5 × 身高(m)²（取 BMI 正常范围中值）'
    ],
    bmiAndHealth: 'BMI 与健康风险',
    bmiAndHealthDesc: '研究表明，BMI 与多种疾病风险相关。BMI 过高会增加 2 型糖尿病、心血管疾病、高血压、某些癌症的风险；BMI 过低则可能导致营养不良、骨质疏松、免疫力下降。保持 BMI 在正常范围内是维护健康的重要基础。'
  },
  exchange: {
    title: '汇率计算',
    subtitle: '多币种实时汇率换算工具',
    inputPlaceholder: '请输入金额',
    resultPlaceholder: '转换结果',
    currentRate: '当前汇率',
    reverseRate: '反向汇率',
    quickConvert: '快速换算',
    ratesTable: '主要货币汇率表（基于人民币）',
    currency: '货币',
    code: '代码',
    toCny: '兑人民币',
    fromCny: '人民币兑',
    refreshRates: '刷新汇率',
    refreshing: '获取中...',
    liveData: '实时数据',
    localData: '本地数据',
    disclaimer: '汇率数据仅供参考，实际交易请以银行柜台或实时行情为准。',
    updateTime: '数据更新时间',
    dataSource: '数据来源',
    currencies: {
      CNY: '人民币',
      USD: '美元',
      EUR: '欧元',
      GBP: '英镑',
      JPY: '日元',
      KRW: '韩元',
      HKD: '港币',
      TWD: '新台币',
      SGD: '新加坡元',
      AUD: '澳元',
      CAD: '加元',
      CHF: '瑞士法郎',
      THB: '泰铢',
      MYR: '马来西亚林吉特',
      RUB: '俄罗斯卢布'
    },
    // 新增原创内容
    whatIsExchangeRate: '什么是汇率？',
    whatIsExchangeRateDesc: '汇率是一种货币兑换另一种货币的比率。例如，美元兑人民币汇率为 7.2，意味着 1 美元可以兑换 7.2 元人民币。汇率受到多种因素影响，包括国家经济状况、利率差异、国际贸易、政治稳定性等。汇率每时每刻都在变动，了解汇率知识对于出国旅行、海外购物、跨境投资都很重要。',
    exchangeRateTypes: '汇率的类型',
    exchangeRateTypesItems: [
      '即期汇率：当前市场上货币兑换的即时价格',
      '远期汇率：约定在未来某一日期进行货币兑换的汇率',
      '买入价/卖出价：银行买入和卖出外币的价格，中间有点差',
      '中间价：买入价和卖出价的平均值，通常用于报价参考'
    ],
    factorsAffectingRates: '影响汇率的因素',
    factorsAffectingRatesItems: [
      '利率差异：高利率国家货币通常会升值，吸引国际资本流入',
      '通货膨胀：高通胀国家货币购买力下降，汇率趋于贬值',
      '贸易顺逆差：贸易顺差国家外汇收入多，本币需求大，利于升值',
      '政治经济稳定性：稳定的国家货币更受信任，汇率更坚挺',
      '央行干预：中央银行可以通过外汇市场操作影响汇率走势'
    ],
    exchangeTips: '换汇实用技巧',
    exchangeTipsItems: [
      '出国旅行前关注汇率走势，在汇率较低时提前换汇',
      '不同银行的汇率和手续费可能不同，可以货比三家',
      '在机场或旅游景点换汇通常汇率较差，尽量避免',
      '使用信用卡境外消费时注意选择当地货币结算（DCC），避免多次汇率转换损失',
      '大额换汇可以考虑分批进行，降低汇率波动风险'
    ],
    currencySymbols: '常见货币符号',
    currencySymbolsDesc: '不同国家的货币有不同的符号表示：¥（人民币/日元）、$（美元）、€（欧元）、£（英镑）、₩（韩元）等。在书写金额时，正确使用货币符号可以避免混淆。',
    rmbInternationalization: '人民币国际化',
    rmbInternationalizationDesc: '近年来，人民币国际化进程不断推进。2016 年，人民币被纳入国际货币基金组织（IMF）的特别提款权（SDR）货币篮子。越来越多的国家和地区开始接受人民币进行贸易结算。人民币汇率形成机制也在不断市场化，参考一篮子货币进行调节。'
  },
  markdown: {
    title: 'Markdown编辑器',
    subtitle: '实时预览的Markdown编辑器，支持常用语法',
    bold: '粗体',
    italic: '斜体',
    heading: '标题',
    list: '无序列表',
    orderedList: '有序列表',
    link: '链接',
    image: '图片',
    inlineCode: '行内代码',
    codeBlock: '代码块',
    quote: '引用',
    divider: '分割线',
    copyMarkdown: '复制Markdown',
    copyHtml: '复制HTML',
    inputLabel: 'Markdown 输入',
    previewLabel: '预览',
    inputPlaceholder: '在此输入Markdown内容...',
    syntaxHelp: 'Markdown 语法参考',
    markdownCopied: 'Markdown已复制！',
    htmlCopied: 'HTML已复制！',
    // 新增原创内容
    whatIsMarkdown: '什么是 Markdown？',
    whatIsMarkdownDesc: 'Markdown 是由约翰·格鲁伯（John Gruber）在 2004 年创建的一种轻量级标记语言。它的设计理念是让人们使用简单、易读的纯文本格式编写文档，然后可以转换成结构化的 HTML。Markdown 语法简洁直观，学习成本低，已成为程序员、技术写作者和内容创作者的首选写作格式。',
    markdownAdvantages: 'Markdown 的优势',
    markdownAdvantagesItems: [
      '语法简单：几分钟即可学会基本语法，上手极快',
      '专注内容：不需要关心排版格式，专心写作',
      '跨平台：纯文本格式，任何编辑器都能打开',
      '版本控制友好：适合用 Git 管理，方便协作和追踪修改',
      '广泛支持：GitHub、GitLab、Notion、语雀等平台都支持'
    ],
    markdownSyntaxGuide: '常用语法一览',
    markdownSyntaxGuideItems: [
      '# 一级标题、## 二级标题、### 三级标题',
      '**粗体** 或 __粗体__',
      '*斜体* 或 _斜体_',
      '[链接文字](URL)',
      '![图片描述](图片URL)',
      '- 无序列表 或 * 无序列表',
      '1. 有序列表',
      '> 引用文字',
      '`行内代码`',
      '```代码块```',
      '--- 或 *** 分割线'
    ],
    markdownUseCases: 'Markdown 应用场景',
    markdownUseCasesItems: [
      '技术文档：README、API 文档、开发指南',
      '博客写作：大多数博客平台支持 Markdown',
      '笔记记录：Notion、Obsidian 等笔记软件首选格式',
      '电子书制作：GitBook、mdBook 等工具',
      '论坛发帖：Stack Overflow、V2EX 等技术社区'
    ],
    markdownTips: 'Markdown 写作技巧',
    markdownTipsItems: [
      '合理使用标题层级，让文档结构清晰',
      '代码块记得标注语言类型，便于语法高亮',
      '善用列表组织并列信息，提高可读性',
      '图片建议使用图床或相对路径管理',
      '复杂表格可以使用在线表格生成器'
    ]
  },
  traditional: {
    title: '繁体字转换',
    subtitle: '简体中文与繁体中文在线互转工具',
    toTraditional: '转为繁体',
    toSimplified: '转为简体',
    swap: '交换',
    inputLabel: '输入文本',
    outputLabel: '转换结果',
    inputPlaceholder: '请输入需要转换的中文文本...',
    outputPlaceholder: '转换后的结果将显示在这里...',
    emptyError: '请输入需要转换的文本',
    toTraditionalSuccess: '已转换为繁体字',
    toSimplifiedSuccess: '已转换为简体字',
    aboutTitle: '关于繁体字',
    aboutDesc1: '繁体字，也称为正体字或传统汉字，是1956年汉字简化方案之前中国通行的标准汉字。繁体字有三千多年的历史，承载着中华民族的文化精髓。',
    aboutUsage: '使用地区：繁体字主要在中国台湾、香港、澳门地区使用；简体字主要在中国大陆及东南亚华人社区使用。',
    aboutValue: '文化价值：繁体字保留了汉字的原始结构和造字理据，对于研究汉字演变、书法艺术和古籍阅读具有重要价值。',
    // 新增原创内容
    simplificationHistory: '汉字简化的历史',
    simplificationHistoryDesc: '1956 年，中华人民共和国国务院公布《汉字简化方案》，开始推行简化字。简化的目的是降低文盲率、方便书写和印刷。简化主要采用以下方法：省略部分笔画、采用草书楷化、用简单符号替代复杂部件、合并同音字等。经过多次调整，现行简化字约有 2000 多个。',
    conversionChallenges: '简繁转换的难点',
    conversionChallengesItems: [
      '一简对多繁：一个简体字可能对应多个繁体字，如「发」对应「發」「髮」',
      '地区用词差异：两岸三地用词习惯不同，如「软件」vs「軟體」、「信息」vs「資訊」',
      '异体字问题：同一个字可能有多种写法，需要根据地区习惯选择',
      '专有名词：人名、地名等专有名词转换需要特别注意'
    ],
    traditionalUseCases: '繁简转换的应用场景',
    traditionalUseCasesItems: [
      '两岸三地商务沟通：企业跨地区交流文档需要转换',
      '学术研究：阅读古籍、港台学术文献',
      '文化创作：书法、篆刻、传统文化内容创作',
      '影视字幕：面向不同地区观众的字幕制作',
      '网站本地化：面向不同地区用户的网站内容适配'
    ],
    learningBenefits: '学习繁体字的好处',
    learningBenefitsItems: [
      '更好地理解汉字造字原理和演变历史',
      '阅读古籍原文，直接感受传统文化',
      '欣赏和学习传统书法艺术',
      '与港台同胞更顺畅地文字交流',
      '提升中文素养，丰富语言表达'
    ],
    commonDifferences: '常见简繁差异示例',
    commonDifferencesItems: [
      '龙/龍、凤/鳳、云/雲、风/風',
      '爱/愛、义/義、国/國、学/學',
      '门/門、开/開、关/關、间/間',
      '车/車、马/馬、鱼/魚、鸟/鳥',
      '书/書、画/畫、乐/樂、体/體'
    ]
  },
  about: {
    title: '关于月升工具网',
    subtitle: '超实用的在线查询工具集合',
    mission: '我们的使命',
    missionDesc: '月升工具网致力于提供简洁、高效、免费的在线工具，帮助用户解决日常工作和生活中的各种问题。我们相信，好的工具应该是简单易用的，不需要下载安装，打开即用。',
    features: '产品特点',
    featureFree: '完全免费',
    featureFreeDesc: '所有工具永久免费使用，无需注册登录',
    featureSecure: '隐私安全',
    featureSecureDesc: '数据在本地处理，不上传服务器',
    featureFast: '快速高效',
    featureFastDesc: '即开即用，无需等待加载',
    featureCross: '跨平台',
    featureCrossDesc: '支持电脑、平板、手机等设备',
    featureDark: '暗黑模式',
    featureDarkDesc: '支持明亮/暗黑主题切换',
    featureUpdate: '持续更新',
    featureUpdateDesc: '不断添加新工具，优化体验',
    toolList: '工具列表',
    contact: '联系我们',
    contactDesc: '如果您有任何建议、反馈或合作意向，欢迎与我们联系。我们非常重视每一位用户的意见，您的反馈将帮助我们不断改进和完善工具。',
    website: '网站',
    email: '邮箱',
    contactPromise: '我们承诺在收到您的反馈后尽快回复。感谢您使用月升工具网！',
    privacyCommitment: '隐私承诺',
    privacyDesc: '月升工具网非常重视您的隐私安全。我们所有的工具都在您的浏览器本地运行，您输入的数据不会被上传到任何服务器。我们不会收集、存储或分享您的个人数据。',
    privacyLink: '详细的隐私保护说明请查看我们的',
    privacyPage: '隐私政策',
    faq: '常见问题',
    faqFree: '网站是免费的吗？',
    faqFreeAnswer: '是的，月升工具网的所有工具都是完全免费的，没有任何隐藏收费。',
    faqRegister: '需要注册账号吗？',
    faqRegisterAnswer: '不需要。您可以直接使用所有工具，无需注册或登录任何账号。',
    faqSuggestion: '可以提出新工具建议吗？',
    faqSuggestionAnswer: '当然可以！我们欢迎您通过邮箱向我们提出新工具的建议，我们会认真考虑每一个建议。',
    story: '网站的故事',
    storyDesc: '月升工具网诞生于一个简单的想法：作为一名开发者，我在日常工作中经常需要使用各种小工具——格式化一段 JSON、转换一个时间戳、计算房贷月供。但每次使用时，要么需要下载安装软件，要么在线工具满屏广告、还要注册登录。我想：为什么不能有一个简洁、免费、无需注册的工具网站呢？于是，月升工具网在 2026 年初正式上线了。',
    storyDesc2: '「月升」这个名字寓意着「月亮升起，照亮黑夜」——我们希望这些小工具能像月光一样，在你需要的时候默默地提供帮助，照亮你的工作和生活。',
    milestones: '发展历程',
    milestonesItems: [
      '2026年1月：网站上线，首批工具包括 JSON 格式化、时间戳转换、字数统计、计算器',
      '2026年1月：新增 Markdown 编辑器、图片处理、繁体字转换、大写金额转换工具',
      '2026年2月：上线房贷计算器、个税计算器、BMI 计算器、汇率换算工具',
      '2026年2月：支持中英文双语切换、暗黑模式，开设技术博客分享原创内容',
      '持续更新中：更多实用工具正在开发中，敬请期待...'
    ],
    techStack: '技术架构',
    techStackDesc: '月升工具网采用现代前端技术栈构建，确保了优秀的性能和用户体验：',
    techStackItems: [
      '前端框架：Vue.js 3，组件化开发，响应式数据驱动',
      '路由管理：Vue Router，支持单页应用的流畅导航',
      '国际化：vue-i18n，支持中英文无缝切换',
      '样式方案：CSS 变量 + 响应式设计，完美适配各种屏幕尺寸',
      '部署方式：静态文件部署，全球 CDN 加速，确保快速访问',
      '隐私设计：所有数据处理均在浏览器本地完成，零数据上传'
    ]
  },
  image: {
    title: '图片处理',
    subtitle: '图片压缩、裁剪、滤镜效果，全部在本地处理，保护隐私',
    uploadHint: '点击或拖拽上传图片',
    supportedFormats: '支持 JPG、PNG、GIF、WebP 格式',
    basicAdjust: '基本调整',
    quality: '质量压缩',
    scale: '缩放比例',
    filterEffects: '滤镜效果',
    imageInfo: '图片信息',
    originalSize: '原始尺寸',
    outputSize: '输出尺寸',
    originalFileSize: '原始大小',
    estimatedSize: '预计大小',
    download: '下载图片',
    reset: '重置',
    clear: '清除',
    filters: {
      none: '原图',
      grayscale: '黑白',
      sepia: '复古',
      invert: '反色',
      blur: '模糊',
      brightness: '增亮',
      contrast: '高对比',
      saturate: '饱和'
    },
    // 新增原创内容
    whyCompress: '为什么需要压缩图片？',
    whyCompressDesc: '在互联网时代，图片是网页和应用中最重要的内容形式之一。然而，高清图片往往体积较大，会影响网页加载速度、消耗用户流量、占用存储空间。合理压缩图片可以在保持视觉质量的同时，大幅减小文件体积，提升用户体验。',
    formatGuide: '常见图片格式详解',
    formatGuideItems: [
      'JPEG/JPG：适合照片和复杂图像，支持有损压缩，不支持透明背景',
      'PNG：支持透明背景和无损压缩，适合图标、Logo、截图',
      'GIF：支持动画和透明，但颜色限制在 256 色，适合简单动图',
      'WebP：Google 开发的现代格式，同质量下体积比 JPEG 小 25-34%',
      'SVG：矢量格式，无限缩放不失真，适合图标和简单图形'
    ],
    compressionTips: '图片压缩技巧',
    compressionTipsItems: [
      '照片类图片使用 JPEG 格式，质量 70-85% 通常足够',
      '需要透明背景的图片使用 PNG 或 WebP',
      '尺寸压缩比质量压缩效果更明显，根据实际显示尺寸调整',
      '批量上传到网站前，建议统一处理图片尺寸和格式',
      '移动端显示的图片可以使用更低的分辨率'
    ],
    privacyNote: '隐私保护说明',
    privacyNoteDesc: '本工具的所有图片处理都在您的浏览器本地完成，您上传的图片不会被发送到任何服务器。处理完成后，图片数据仅存在于您的设备中，关闭页面后即被清除。您可以放心处理包含敏感信息的图片。',
    webOptimization: '网页图片优化建议',
    webOptimizationItems: [
      '首屏图片优先加载，非首屏图片使用懒加载',
      '根据设备像素比提供不同分辨率的图片（响应式图片）',
      '使用 CDN 加速图片访问，启用缓存策略',
      '考虑使用 WebP 格式，并为不支持的浏览器提供 JPEG 回退',
      '压缩后图片建议控制在 200KB 以内'
    ]
  },
  uppercase: {
    title: '大写金额转换',
    subtitle: '将阿拉伯数字金额转换为中文大写金额',
    inputLabel: '输入金额（数字）',
    inputPlaceholder: '请输入金额，如：12345.67',
    outputLabel: '大写金额',
    waiting: '等待输入...',
    quickExamples: '快速示例',
    digitTable: '大写数字对照表',
    arabicDigit: '阿拉伯数字',
    chineseUppercase: '中文大写',
    unitInfo: '单位大写',
    unitValues: '拾（十）、佰（百）、仟（千）、万、亿',
    amountUnit: '金额单位',
    amountUnitValues: '元（圆）、角、分、整',
    usageTips: '使用说明',
    tips: [
      '支持输入最大金额：9999999999999.99（约10万亿）',
      '小数位最多支持2位（分）',
      '常用于支票、银行单据、财务凭证等正式场合',
      '大写金额可有效防止金额被篡改'
    ],
    invalidFormat: '请输入有效的金额格式',
    negativeError: '金额不能为负数',
    overflowError: '金额超出转换范围',
    zero: '零元整',
    // 新增原创内容
    whyUppercase: '为什么要使用大写金额？',
    whyUppercaseDesc: '大写金额是中国财务规范中的重要要求，主要目的是防止金额被篡改。阿拉伯数字容易被添加或修改（如把 1 改成 7，100 改成 1000），而中文大写数字结构复杂，难以伪造或涂改。因此，支票、合同、借据等重要财务文件都要求同时填写大写金额。',
    uppercaseHistory: '大写数字的历史',
    uppercaseHistoryDesc: '中国使用大写数字防伪的历史可以追溯到明朝。据传，明太祖朱元璋因为发生贪污案件，下令在官方文书中使用大写数字，以防止官吏篡改数字贪污。这一制度一直沿用至今，成为中国财务管理的重要传统。',
    writingRules: '大写金额书写规范',
    writingRulesItems: [
      '中文大写金额数字前应标明「人民币」字样',
      '大写金额数字应紧接「人民币」字样填写，不得留有空白',
      '阿拉伯数字中间有 0 时，中文大写要写「零」',
      '金额数字到元为止的，在元后面写「整」或「正」',
      '金额数字有角无分的，在角后面写「整」或「正」'
    ],
    commonMistakes: '常见书写错误',
    commonMistakesItems: [
      '使用简化字：应使用「壹贰叁」而非「一二三」',
      '漏写单位：每个数字后都要写对应的单位',
      '零的处理：连续的零只写一个「零」',
      '「元」的写法：可写「元」或「圆」，但应统一',
      '末尾处理：元后无角分要写「整」'
    ],
    uppercaseExamples: '实际应用示例',
    uppercaseExamplesItems: [
      '¥1,234.56 → 人民币壹仟贰佰叁拾肆元伍角陆分',
      '¥10,000.00 → 人民币壹万元整',
      '¥305.40 → 人民币叁佰零伍元肆角整',
      '¥1,000,000.00 → 人民币壹佰万元整'
    ]
  },
  privacy: {
    title: '隐私政策',
    lastUpdate: '最后更新日期：2026年2月5日',
    overview: '概述',
    overviewDesc: '欢迎访问月升工具网（ysgjw.com）。我们非常重视您的隐私，本隐私政策说明了我们如何收集、使用和保护您的信息。',
    collection: '信息收集',
    autoCollection: '自动收集的信息',
    autoCollectionDesc: '当您访问本网站时，我们可能会自动收集以下信息：',
    autoCollectionItems: [
      '设备信息（浏览器类型、操作系统）',
      '访问时间和日期',
      '访问的页面和使用的功能',
      'IP 地址（用于确定大致地理位置）',
      '引荐来源（您从哪个网站访问我们）'
    ],
    userProvided: '您主动提供的信息',
    userProvidedDesc: '本网站的工具均在您的浏览器本地运行，我们不会收集您输入的任何数据内容，包括但不限于：',
    userProvidedItems: ['JSON 数据', '文本内容', '计算数值', '上传的图片'],
    dataControl: '您的数据安全由您自己掌控，所有处理均在本地完成。',
    cookies: 'Cookie 和追踪技术',
    cookiesDesc: '我们使用以下技术来改善用户体验：',
    googleAnalytics: 'Google Analytics',
    googleAnalyticsDesc: '我们使用 Google Analytics 来分析网站流量和用户行为，帮助我们改进网站。Google Analytics 会使用 Cookie 收集匿名的使用数据。您可以通过浏览器设置禁用 Cookie，或安装',
    gaOptout: 'Google Analytics 停用插件',
    localStorage: '本地存储',
    localStorageDesc: '我们可能使用浏览器本地存储（localStorage）来保存您的偏好设置，如主题模式（明亮/暗黑）。这些数据仅存储在您的设备上。',
    advertising: '广告',
    advertisingDesc: '本网站可能展示第三方广告（如 Google AdSense）。这些广告服务商可能会使用 Cookie 来展示与您兴趣相关的广告。您可以访问',
    adSettings: 'Google 广告设置',
    adSettingsLink: '来管理广告偏好。',
    sharing: '信息共享',
    sharingDesc: '我们不会出售、交易或以其他方式将您的个人信息转让给第三方，除非：',
    sharingItems: ['获得您的明确同意', '法律要求或政府机关依法要求', '保护我们的权利、财产或安全'],
    security: '数据安全',
    securityDesc: '我们采取合理的技术和组织措施来保护您的信息安全：',
    securityItems: ['使用 HTTPS 加密传输', '定期更新和维护网站安全', '限制对用户数据的访问'],
    children: '儿童隐私',
    childrenDesc: '本网站不面向 13 岁以下的儿童。我们不会故意收集儿童的个人信息。',
    rights: '您的权利',
    rightsDesc: '您有权：',
    rightsItems: ['了解我们收集了哪些信息', '要求删除您的信息', '选择退出数据收集（通过禁用 Cookie）', '对本隐私政策提出疑问'],
    updates: '隐私政策更新',
    updatesDesc: '我们可能会不时更新本隐私政策。更新后的政策将在本页面发布，并更新"最后更新日期"。建议您定期查看本页面。',
    contact: '联系我们',
    contactDesc: '如果您对本隐私政策有任何疑问，请通过以下方式联系我们：'
  },
  textDedup: {
    title: '文本去重工具',
    subtitle: '快速去除文本中的重复内容，支持按行、按逗号、按句子等多种分隔方式',
    dedup: '开始去重',
    inputLabel: '输入文本',
    outputLabel: '去重结果',
    inputPlaceholder: '请输入或粘贴需要去重的文本...',
    outputPlaceholder: '去重后的结果将显示在这里...',
    trimLines: '去除首尾空格',
    ignoreCase: '忽略大小写',
    ignoreEmpty: '忽略空项',
    splitMode: '分割方式：',
    splitByLine: '按行分割',
    splitByComma: '按逗号分割',
    splitBySentence: '按句子分割',
    splitByCustom: '自定义分隔符',
    customSepPlaceholder: '输入分隔符',
    success: '去重完成！',
    statsInfo: '共 {total} 项，去除 {removed} 个重复项，剩余 {remain} 项',
    whatIs: '什么是文本去重？',
    whatIsDesc: '文本去重是指从一段文本中移除重复出现的行或内容。在日常工作中，我们经常会遇到从数据库导出的数据、日志文件、邮件列表等包含大量重复项的情况。手动删除这些重复数据既耗时又容易遗漏，使用文本去重工具可以一键完成清理，大幅提高工作效率。本工具完全在浏览器本地运行，您的数据不会被上传到任何服务器，安全可靠。',
    useCasesTitle: '文本去重的应用场景',
    useCases: [
      '数据清洗：清理从数据库、Excel 导出的重复记录',
      '邮件列表整理：去除重复的邮箱地址或联系人信息',
      '日志分析：过滤重复的日志条目，快速定位问题',
      '关键词整理：SEO 关键词列表去重，避免重复投放',
      '代码开发：清理重复的配置项、URL 列表或 IP 地址'
    ],
    featuresTitle: '工具功能特点',
    features: [
      '支持按行去重，精确匹配每一行内容',
      '可选忽略大小写，灵活处理英文文本',
      '自动过滤空行，保持结果整洁',
      '实时统计去重数量，一目了然',
      '所有处理在浏览器本地完成，保护数据隐私'
    ],
    tipsTitle: '使用技巧',
    tips: [
      '处理大量数据时，建议先勾选"忽略空行"以减少干扰',
      '英文数据去重时，可以勾选"忽略大小写"避免因大小写不同而保留重复项',
      '去重后可以配合"文本排序"工具对结果进行排序整理',
      '如果需要保留原始顺序，本工具默认保留每个重复项的首次出现'
    ]
  },
  textReplace: {
    title: '文本替换工具',
    subtitle: '在线文本查找与替换，支持正则表达式',
    findLabel: '查找内容',
    replaceLabel: '替换为',
    findPlaceholder: '输入要查找的文本...',
    replacePlaceholder: '输入替换后的文本（留空则删除匹配内容）',
    replace: '执行替换',
    ignoreCase: '忽略大小写',
    useRegex: '使用正则表达式',
    replaceAll: '全部替换',
    inputLabel: '输入文本',
    outputLabel: '替换结果',
    inputPlaceholder: '请输入或粘贴需要处理的文本...',
    outputPlaceholder: '替换后的结果将显示在这里...',
    emptyFind: '请输入要查找的内容',
    success: '替换完成！',
    regexError: '正则表达式错误',
    countInfo: '共替换 {n} 处',
    whatIs: '什么是文本替换？',
    whatIsDesc: '文本替换是文本编辑中最基础也最常用的功能之一。无论是修改文档中的特定词汇、批量更新代码中的变量名，还是清理文本中的特定字符，文本替换工具都能帮你快速完成。本工具不仅支持简单的文本查找替换，还支持强大的正则表达式匹配，可以实现复杂的文本处理需求。所有操作在浏览器本地完成，保护您的数据安全。',
    useCasesTitle: '文本替换的应用场景',
    useCases: [
      '批量修改文档内容：替换过时的产品名称、联系方式等信息',
      '代码重构：批量替换变量名、函数名或 API 地址',
      '数据格式转换：将逗号分隔符替换为制表符，或反向操作',
      '清理特殊字符：去除多余的空格、换行符或不可见字符',
      '内容审核：将敏感词替换为星号或其他替代文本'
    ],
    regexTitle: '正则表达式入门',
    regexDesc: '正则表达式是一种强大的文本匹配模式，可以实现复杂的查找替换操作。以下是一些常用的正则表达式示例：',
    regexExamples: [
      '\\d+ 匹配一个或多个数字，如匹配 "abc123" 中的 "123"',
      '\\s+ 匹配一个或多个空白字符，可用于将多个空格替换为单个空格',
      '^\\s+ 匹配行首的空格，可用于去除缩进',
      '\\s+$ 匹配行尾的空格，可用于去除尾随空格',
      '<[^>]+> 匹配HTML标签，可用于去除HTML代码中的标签',
      '(\\d{4})-(\\d{2})-(\\d{2}) 匹配日期格式，可以用 $3/$2/$1 重新排列'
    ]
  },
  textSort: {
    title: '文本排序工具',
    subtitle: '对文本按行排序、反转或随机打乱顺序',
    sortAsc: '升序排列',
    sortDesc: '降序排列',
    reverse: '反转顺序',
    shuffle: '随机打乱',
    ignoreCase: '忽略大小写',
    numericSort: '按数字排序',
    removeEmpty: '移除空行',
    inputLabel: '输入文本',
    outputLabel: '排序结果',
    inputPlaceholder: '请输入或粘贴需要排序的文本，每行一条数据...',
    outputPlaceholder: '排序后的结果将显示在这里...',
    success: '排序完成！',
    whatIs: '什么是文本排序？',
    whatIsDesc: '文本排序工具可以对文本内容按行进行排序处理。支持按字母升序（A-Z）、降序（Z-A）排列，也支持反转行顺序和随机打乱。对于中文文本，会按照拼音顺序排列；对于包含数字的文本，可以启用数字排序模式。该工具在数据整理、列表排序、代码格式化等场景中非常实用，所有处理都在浏览器本地完成。',
    useCasesTitle: '文本排序的应用场景',
    useCases: [
      '字母表排序：将名单、词汇表按字母或拼音顺序排列',
      '数据整理：将数值数据从小到大或从大到小排列',
      '代码格式化：将 import 语句、CSS 属性按字母排序',
      '反转文本：将最后一行移到第一行，用于逆序查看日志',
      '随机排列：打乱选项顺序，适用于抽签、随机排序等场景',
      '去重排序：配合去重工具，先去重再排序，生成整洁的列表'
    ],
    featuresTitle: '工具功能特点',
    features: [
      '支持升序、降序、反转和随机四种排序方式',
      '中文按拼音排序，英文按字母排序',
      '数字排序模式：将 "2" 排在 "10" 前面（而非字符串排序的 "10" 在 "2" 前）',
      '可选忽略大小写，让 "apple" 和 "Apple" 排在一起',
      '自动过滤空行，保持结果整洁'
    ]
  },
  textNumber: {
    title: '文本添加序号',
    subtitle: '为文本每行自动添加编号，支持多种格式',
    startNum: '起始序号',
    separator: '分隔符',
    position: '序号位置',
    before: '行首',
    after: '行尾',
    tab: '制表符',
    skipEmpty: '跳过空行',
    padZero: '序号补零',
    addNumber: '添加序号',
    removeNumber: '移除序号',
    inputLabel: '输入文本',
    outputLabel: '处理结果',
    inputPlaceholder: '请输入或粘贴需要添加序号的文本，每行一条...',
    outputPlaceholder: '添加序号后的结果将显示在这里...',
    success: '序号添加完成！',
    removeSuccess: '序号移除完成！',
    whatIs: '什么是文本添加序号？',
    whatIsDesc: '文本添加序号工具可以为文本的每一行自动添加编号。无论是整理学习笔记、制作编号列表、还是处理数据文件，都可以快速完成。支持多种序号格式（如 "1." "1)" "1、" 等），可以自定义起始数字，还能选择将序号添加在行首或行尾。同时也支持一键移除已有序号，方便反复编辑。',
    useCasesTitle: '应用场景',
    useCases: [
      '整理笔记：为学习笔记或会议纪要添加编号',
      '制作清单：快速为待办事项、购物清单等添加序号',
      '文档编辑：为合同条款、规章制度添加条目编号',
      '数据处理：为 CSV 数据行添加行号便于后续引用',
      '代码注释：为代码行添加行号方便讨论和审查'
    ]
  },
  text2html: {
    title: '文本转HTML工具',
    subtitle: '将纯文本一键转换为HTML格式代码',
    modeParagraph: '转为段落 <p>',
    modeList: '转为列表 <ul>',
    modeBr: '转为换行 <br>',
    modeTable: '转为表格 <table>',
    inputLabel: '输入纯文本',
    outputLabel: 'HTML代码',
    inputPlaceholder: '请输入纯文本内容，每行一段...\n\n表格模式下，使用逗号或制表符分隔列数据',
    outputPlaceholder: '转换后的HTML代码将显示在这里...',
    preview: 'HTML预览',
    success: '转换成功！',
    whatIs: '什么是文本转HTML？',
    whatIsDesc: '文本转HTML工具可以将普通的纯文本内容快速转换为HTML格式的代码。在网页开发、博客编辑、邮件编写等场景中，经常需要将纯文本转换为HTML格式。手动添加HTML标签不仅繁琐还容易出错，使用本工具可以一键完成转换，并且支持段落、列表、换行和表格等多种转换模式，满足不同的排版需求。',
    useCasesTitle: '应用场景',
    useCases: [
      '博客编辑：将纯文本文章转换为HTML格式发布到网站',
      '邮件编写：制作HTML格式的邮件内容',
      '网页开发：快速生成HTML结构代码',
      '数据展示：将CSV数据转换为HTML表格展示',
      '文档转换：将纯文本列表转换为HTML有序或无序列表'
    ],
    modesTitle: '转换模式说明',
    modesDesc: [
      '段落模式：每行文本转换为一个 <p> 标签包裹的段落',
      '列表模式：每行文本转换为 <li> 标签，整体包裹在 <ul> 标签中',
      '换行模式：每行之间用 <br> 标签连接，适合简单的换行需求',
      '表格模式：将逗号或制表符分隔的数据转换为HTML表格，第一行作为表头'
    ]
  },
  wordFreq: {
    title: '词频统计工具',
    subtitle: '分析文本中词语出现的频率和分布情况',
    analyze: '开始统计',
    ignoreCase: '忽略大小写',
    ignorePunctuation: '忽略标点符号',
    skipSingleChinese: '中文不统计单个字',
    skipPureNumbers: '不统计纯数字',
    skipEnglishPrepositions: '英文不统计介词/虚词',
    topN: '显示数量',
    inputLabel: '输入文本',
    inputPlaceholder: '请输入或粘贴需要统计词频的文本...',
    resultTitle: '词频统计结果',
    totalWords: '共计 {n} 个词',
    word: '词语',
    count: '出现次数',
    percent: '占比',
    bar: '频率分布',
    success: '统计完成！',
    whatIs: '什么是词频统计？',
    whatIsDesc: '词频统计是文本分析中最基础也最重要的方法之一。通过统计文本中每个词语出现的次数和频率，可以快速了解文本的主题和关键信息。词频分析广泛应用于语言学研究、自然语言处理、搜索引擎优化、内容分析等领域。本工具支持中英文混合文本的词频统计，中文自动分词、英文按空格分词，以可视化方式展示统计结果。',
    useCasesTitle: '词频统计的应用场景',
    useCases: [
      'SEO 优化：分析网页内容中关键词的密度和分布',
      '内容分析：了解文章的核心主题和高频词汇',
      '学术研究：分析语料库中的词频分布规律',
      '竞品分析：对比分析竞争对手的内容策略和关键词使用',
      '写作改进：检查是否过度使用某些词汇，提升文章质量',
      '语言学习：统计外语文本中的高频词汇，辅助记忆学习'
    ],
    tipsTitle: '使用技巧',
    tips: [
      '勾选"忽略大小写"可以将 Hello 和 hello 合并统计',
      '勾选"中文不统计单个字"可以过滤单字，只保留词语（如"优化""样式"等）',
      '勾选"不统计纯数字"可以过滤掉文本中的数字',
      '勾选"英文不统计介词/虚词"可以过滤 the、in、of 等常见虚词',
      '中文会自动进行分词，识别常用词语组合',
      '增大"显示数量"可以查看更多低频词的统计结果'
    ]
  },
  namingConverter: {
    title: '命名转换器',
    subtitle: '在不同编程命名规范之间快速转换，支持驼峰、下划线、短横线等多种格式',
    inputLabel: '输入标识符名称',
    inputPlaceholder: '输入任意格式的变量名，如 myVariableName、my_variable_name、my-variable-name...',
    whatIs: '什么是命名转换器？',
    whatIsDesc: '在编程中，不同的语言和场景使用不同的命名规范。命名转换器可以帮助你在各种命名格式之间快速切换，避免手动修改的繁琐和错误。只需输入一种格式的名称，即可自动生成所有其他格式的变体。所有转换在浏览器本地完成，安全可靠。',
    stylesTitle: '常见命名格式说明',
    styles: [
      'camelCase（小驼峰）：JavaScript 变量和函数名的标准，如 getUserName',
      'PascalCase（大驼峰）：类名和组件名常用，如 UserProfile',
      'snake_case（下划线）：Python、Ruby 和数据库字段的标准，如 user_name',
      'kebab-case（短横线）：HTML 属性、CSS 类名和 URL 的标准，如 user-profile',
      'CONSTANT_CASE（常量）：全大写+下划线，用于常量定义，如 MAX_RETRY_COUNT',
      'dot.case（点号分隔）：用于配置文件和包名，如 com.example.app',
      'path/case（路径分隔）：用于文件路径，如 user/profile/avatar',
      'Title Case（标题格式）：每个单词首字母大写，如 User Profile Name',
      'Sentence case（句子格式）：仅首字母大写，如 User profile name'
    ],
    tipsTitle: '使用技巧',
    tips: [
      '输入时支持自动识别 camelCase、PascalCase、snake_case、kebab-case 等格式',
      '也支持输入空格分隔的普通文本，会自动拆分为单词',
      '点击每种格式右侧的复制按钮可快速复制结果'
    ]
  },
  regexTester: {
    title: '正则表达式测试',
    subtitle: '在线测试和调试正则表达式，实时高亮匹配结果',
    patternPlaceholder: '输入正则表达式...',
    testString: '测试文本',
    testPlaceholder: '输入要匹配的文本...',
    matchResult: '匹配结果',
    matchCount: '共 {n} 个匹配',
    matchDetails: '匹配详情',
    matchValue: '匹配内容',
    matchPos: '位置',
    matchGroups: '捕获分组',
    quickRef: '快速参考（点击插入）',
    ref: {
      dot: '任意字符',
      digit: '数字 [0-9]',
      word: '单词字符 [a-zA-Z0-9_]',
      space: '空白字符',
      start: '行首',
      end: '行尾',
      star: '0次或多次',
      plus: '1次或多次',
      question: '0次或1次',
      charset: '字符集合',
      group: '捕获分组',
      or: '或运算'
    },
    whatIs: '什么是正则表达式？',
    whatIsDesc: '正则表达式（Regular Expression，简称 Regex）是一种用于描述文本匹配模式的强大工具。它可以用来搜索、验证、替换和提取文本中的特定内容。正则表达式被广泛应用于编程语言、文本编辑器、命令行工具等场景。本工具支持实时测试正则表达式，高亮显示匹配结果，并显示捕获分组的详细信息。所有处理在浏览器本地完成。',
    useCasesTitle: '正则表达式的应用场景',
    useCases: [
      '表单验证：验证邮箱、手机号、身份证号等格式是否正确',
      '数据提取：从日志、网页或文本中提取特定格式的数据',
      '文本替换：批量替换特定模式的文本内容',
      '日志分析：从海量日志中筛选关键信息',
      '代码重构：在IDE中使用正则搜索替换进行批量代码修改',
      '爬虫开发：从HTML页面中提取所需数据'
    ]
  },
  colorConverter: {
    title: '颜色值转换工具',
    subtitle: '在 HEX、RGB、HSL 等颜色格式之间互相转换，带实时预览',
    pickerLabel: '使用取色器：',
    whatIs: '什么是颜色值转换？',
    whatIsDesc: '在前端开发和设计中，颜色可以用多种格式表示：HEX（十六进制）、RGB（红绿蓝）、HSL（色相饱和度亮度）等。不同的场景和工具可能需要不同的颜色格式。颜色值转换工具可以帮助你在各种格式之间快速转换，并提供实时颜色预览。所有处理在浏览器本地完成。',
    formatsTitle: '颜色格式详解',
    formats: [
      'HEX（十六进制）：如 #FF5733，是CSS中最常用的颜色格式，由 # 加6位十六进制数组成',
      'RGB（红绿蓝）：如 rgb(255, 87, 51)，用0-255表示红、绿、蓝三个颜色通道的值',
      'RGBA：在 RGB 基础上增加透明度通道（Alpha），如 rgba(255, 87, 51, 0.8)',
      'HSL（色相饱和度亮度）：如 hsl(9, 100%, 60%)，更符合人类对颜色的直觉理解',
      'HSLA：在 HSL 基础上增加透明度通道'
    ],
    tipsTitle: '使用技巧',
    tips: [
      '可以直接编辑任何一种格式的输入框，其他格式会自动同步更新',
      '使用取色器可以直接从调色板选择颜色',
      '点击每种格式右侧的复制按钮可快速复制 CSS 颜色值',
      'HEX 格式支持 3 位简写（如 #F00）自动展开为 6 位'
    ]
  },
  codeFormatter: {
    title: '代码格式化工具',
    subtitle: '在线格式化和压缩 CSS、JavaScript、HTML、SQL 代码',
    format: '格式化',
    compress: '压缩',
    inputLabel: '输入代码',
    outputLabel: '输出结果',
    outputPlaceholder: '格式化/压缩后的结果将显示在这里...',
    formatSuccess: '格式化成功！',
    compressSuccess: '压缩成功！',
    formatError: '格式化出错',
    whatIs: '什么是代码格式化？',
    whatIsDesc: '代码格式化（也叫代码美化）是将压缩或混乱的代码转换为结构清晰、缩进整齐的格式，方便阅读和维护。代码压缩则是反向操作，去除不必要的空白和换行，减小文件体积，优化加载性能。本工具支持 CSS、JavaScript、HTML 和 SQL 四种常用代码语言的格式化和压缩，所有操作在浏览器本地完成。',
    featuresTitle: '工具功能特点',
    features: [
      'CSS 格式化/压缩：美化样式代码或移除注释和空格以减小文件大小',
      'JavaScript 格式化/压缩：自动缩进 JS 代码，或去除空白减小体积',
      'HTML 格式化/压缩：整理 HTML 标签缩进结构，或合并为单行',
      'SQL 格式化/压缩：将 SQL 语句关键字大写并换行排列，或压缩为单行',
      '一键切换语言，同一界面处理多种代码格式'
    ]
  },
  crontab: {
    title: 'Crontab时间计算',
    subtitle: '解析 Crontab 定时任务表达式，预览未来执行时间',
    expressionLabel: 'Crontab 表达式',
    presets: '常用预设',
    nextRunsLabel: '未来 10 次执行时间',
    errorFormat: 'Crontab 表达式格式错误，需要 5 个字段（分 时 日 月 周）',
    field: {
      minute: '分钟',
      hour: '小时',
      day: '日',
      month: '月',
      weekday: '星期'
    },
    week: {
      sun: '周日', mon: '周一', tue: '周二', wed: '周三', thu: '周四', fri: '周五', sat: '周六'
    },
    preset: {
      everyMinute: '每分钟',
      everyHour: '每小时整点',
      everyDay: '每天零点',
      weekday9am: '工作日上午9点',
      everySunday: '每周日零点',
      everyMonth: '每月1号零点',
      every5min: '每5分钟',
      every2hours: '每2小时',
      everyMonday: '每周一零点',
      everyYear: '每年1月1日'
    },
    desc: {
      everyMinute: '每分钟执行一次',
      everyNMin: '每 {n} 分钟',
      atMinute: '第 {n} 分钟',
      everyNHour: '每 {n} 小时',
      atHour: '{n} 点',
      everyNDay: '每 {n} 天',
      onDay: '每月 {n} 号',
      inMonth: '{n} 月',
      onWeekday: '星期 {n}'
    },
    whatIs: '什么是 Crontab？',
    whatIsDesc: 'Crontab 是 Unix/Linux 系统中用于设置定时任务（周期性执行的命令）的工具。Crontab 表达式由 5 个字段组成，分别表示分钟、小时、日期、月份和星期，用空格分隔。通过组合这些字段，可以灵活定义各种执行周期。本工具可以帮助你解析和验证 Crontab 表达式，预览未来的执行时间。',
    syntaxTitle: 'Crontab 语法说明',
    syntaxItems: [
      '格式：分钟(0-59) 小时(0-23) 日(1-31) 月(1-12) 星期(0-7，0和7都表示周日)',
      '* 表示任意值（每个时间单位都匹配）',
      '*/n 表示每隔 n 个单位执行，如 */5 表示每5分钟',
      'a-b 表示范围，如 1-5 表示周一到周五',
      'a,b,c 表示列举，如 1,15 表示每月1号和15号',
      '可以组合使用，如 0 9-17 * * 1-5 表示工作日每小时整点(9-17点)'
    ],
    tipsTitle: '使用技巧',
    tips: [
      '点击常用预设可以快速填入表达式',
      '修改表达式后实时显示解析结果和未来执行时间',
      '注意：星期字段中 0 和 7 都代表周日',
      '在 Linux 服务器上使用 crontab -e 命令编辑定时任务'
    ]
  },
  qrGenerator: {
    title: '二维码生成器',
    subtitle: '在线生成二维码，支持自定义大小、颜色和纠错级别',
    contentLabel: '二维码内容',
    contentPlaceholder: '输入文本、网址、电话号码等...',
    sizeLabel: '图片大小',
    fgColor: '前景色',
    bgColor: '背景色',
    ecLevel: '纠错级别',
    ecUpgradeHint: '添加 Logo 后纠错级别将自动提升至 H，以确保二维码可正常扫描',
    moduleStyle: '码点样式',
    styles: {
      square: '方块',
      rounded: '圆角',
      dots: '圆点',
      diamond: '菱形'
    },
    logoLabel: 'Logo 图片',
    logoUploadHint: '点击或拖拽上传 Logo 图片',
    logoRemove: '移除 Logo',
    logoSize: 'Logo 大小',
    emptyHint: '请输入内容生成二维码',
    downloadPNG: '下载 PNG',
    downloadSVG: '下载 SVG',
    copy: '复制图片',
    copySuccess: '已复制到剪贴板！',
    copyFail: '复制失败，请手动保存',
    whatIs: '什么是二维码？',
    whatIsDesc: '二维码（QR Code）是一种二维条形码，能够存储文本、网址、联系方式等信息。扫描二维码可以快速获取其中的内容。二维码广泛应用于支付、名片分享、产品溯源、网站链接等场景。本工具支持在线生成自定义二维码，所有操作在浏览器本地完成。',
    useCasesTitle: '常见应用场景',
    useCases: [
      '网址链接分享：将网页地址转为二维码，方便手机扫码访问',
      'WiFi 连接：生成 WiFi 连接信息二维码，扫一扫即可连接',
      '电子名片：将联系方式编码为二维码，方便快速添加',
      '支付收款：生成收款二维码用于转账和支付',
      '产品溯源：将产品信息编码为二维码贴在商品包装上'
    ],
    tipsTitle: '使用技巧',
    tips: [
      '纠错级别越高（H > Q > M > L），二维码越复杂但容错能力越强',
      '建议使用深色前景和浅色背景，确保足够的对比度以便扫描',
      '添加 Logo 后纠错级别会自动提升至 H，Logo 建议不超过 25% 以确保可扫描',
      '生成的二维码建议先用手机扫描验证后再使用',
      'SVG 格式适合印刷场景，可无损缩放到任意尺寸'
    ]
  },
  qrScanner: {
    title: '二维码解析器',
    subtitle: '上传图片识别二维码内容，支持拖拽和粘贴',
    uploadHint: '点击上传或拖拽图片到此处',
    uploadSub: '支持 JPG、PNG、GIF、WebP 等格式',
    resultLabel: '识别结果',
    copy: '复制',
    copySuccess: '已复制！',
    copyFail: '复制失败',
    openLink: '在新标签页中打开链接',
    scanning: '正在识别中...',
    emptyResult: '上传包含二维码的图片即可识别',
    noQrFound: '未在图片中检测到二维码，请检查图片是否包含清晰的二维码',
    libLoading: '解析库正在加载中，请稍后重试',
    reset: '重新选择',
    pasteHint: '你也可以直接 Ctrl+V (Cmd+V) 粘贴截图来识别二维码',
    whatIs: '什么是二维码解析？',
    whatIsDesc: '二维码解析是从二维码图片中提取编码信息的过程。通过上传包含二维码的图片，本工具可以自动识别并解码其中的文本、网址等内容。所有图片处理都在浏览器本地完成，不会上传到任何服务器，保护您的隐私安全。',
    tipsTitle: '使用技巧',
    tips: [
      '确保二维码图片清晰，避免模糊或遮挡',
      '支持直接粘贴截图（Ctrl+V / Cmd+V）',
      '支持拖拽图片文件到上传区域',
      '如果识别失败，尝试裁剪图片让二维码占据更大面积',
      '所有处理在本地完成，不会上传图片到服务器'
    ]
  },
  taxRate: {
    title: '税金税率计算器',
    subtitle: '根据金额和税率快速计算税金，支持含税/不含税金额互算',
    modeIncluded: '已知含税金额',
    modeExcluded: '已知不含税金额',
    amountIncluded: '含税金额',
    amountExcluded: '不含税金额',
    inputPlaceholder: '请输入金额',
    yuan: '元',
    rateLabel: '税率',
    taxAmount: '税额',
    excludedAmount: '不含税金额',
    includedAmount: '含税金额',
    rateUsed: '使用税率',
    commonRatesTitle: '常用增值税税率',
    tableRate: '税率',
    tableScope: '适用范围',
    rateItems: [
      { rate: '13%', scope: '销售货物、加工修理修配劳务、有形动产租赁等' },
      { rate: '9%', scope: '交通运输、邮政、基础电信、建筑、不动产租赁、销售不动产、转让土地使用权、农产品等' },
      { rate: '6%', scope: '金融服务、现代服务、生活服务、增值电信、销售无形资产等' },
      { rate: '5%', scope: '房产租赁（简易计税）、不动产销售（简易计税）等' },
      { rate: '3%', scope: '小规模纳税人适用征收率' },
      { rate: '1%', scope: '小规模纳税人减按1%征收（阶段性优惠政策）' }
    ],
    whatIs: '什么是税金税率计算？',
    whatIsDesc: '税金税率计算是指根据商品或服务的金额和适用的税率，计算应缴纳的税额。在商业活动中，经常需要在含税价格和不含税价格之间进行转换。本工具支持双向计算，帮助您快速完成税金相关的计算工作。所有计算在浏览器本地完成。',
    formulaTitle: '计算公式',
    formulas: [
      '含税金额 = 不含税金额 × (1 + 税率)',
      '不含税金额 = 含税金额 ÷ (1 + 税率)',
      '税额 = 含税金额 - 不含税金额',
      '税额 = 不含税金额 × 税率'
    ]
  },
  listSum: {
    title: '列表求和计算器',
    subtitle: '对一组数字快速求和，同时提供平均值、最大值、最小值等统计信息',
    inputLabel: '输入数字列表',
    inputPlaceholder: '每行输入一个数字，例如：\n100\n200.5\n300\n-50\n150.75',
    separatorLabel: '分隔方式：',
    sepLine: '按行',
    sepComma: '按逗号',
    sepSpace: '按空格',
    sepTab: '按 Tab',
    ignoreNonNumber: '忽略非数字项',
    decimalMode: '高精度小数',
    sum: '求和结果',
    average: '平均值',
    count: '数字个数',
    max: '最大值',
    min: '最小值',
    median: '中位数',
    parsedList: '识别到的数字',
    skippedInfo: '已跳过 {n} 个非数字项',
    whatIs: '什么是列表求和？',
    whatIsDesc: '列表求和计算器可以对一组数字快速进行求和运算，同时自动计算平均值、最大值、最小值和中位数等常用统计指标。支持多种分隔方式（换行、逗号、空格、Tab），可以直接粘贴从表格或文档中复制的数据。所有计算在浏览器本地完成。',
    tipsTitle: '使用技巧',
    tips: [
      '可以直接从 Excel、WPS 等表格软件中复制一列数据粘贴到输入框',
      '支持负数和小数，如 -100 和 3.14',
      '支持千分位格式的数字，如 1,234,567.89 会自动识别',
      '如果数据中混有文字，勾选"忽略非数字项"可以自动过滤',
      '切换不同的分隔方式来适配不同格式的数据'
    ]
  },
  loanCalc: {
    title: '贷款计算器',
    subtitle: '通用贷款月供计算工具，支持等额本息和等额本金两种还款方式',
    amountLabel: '贷款金额',
    yuan: '元',
    rateLabel: '年利率',
    termLabel: '贷款期限',
    months: '个月',
    quickTerm: '快速选择：',
    methodEqual: '等额本息',
    methodPrincipal: '等额本金',
    monthlyPayment: '每月还款',
    firstMonthPayment: '首月还款',
    lastMonthPayment: '末月还款',
    totalInterest: '利息总额',
    totalPayment: '还款总额',
    scheduleTitle: '还款明细',
    show: '展开',
    hide: '收起',
    period: '期数',
    monthlyPaymentCol: '月供',
    principalCol: '本金',
    interestCol: '利息',
    remainingCol: '剩余本金',
    whatIs: '什么是贷款计算器？',
    whatIsDesc: '贷款计算器可以帮助您根据贷款金额、年利率和还款期限，计算每月应还款额、利息总额和还款总额。支持等额本息和等额本金两种常见的还款方式。可用于消费贷、车贷、经营贷等各类贷款的月供计算。所有计算在浏览器本地完成。',
    methodsTitle: '还款方式说明',
    methods: [
      '等额本息：每月还款金额固定不变，前期利息占比较高，后期本金占比逐渐增加。适合收入稳定的借款人。',
      '等额本金：每月偿还的本金固定，利息逐月递减，每月还款额逐步减少。前期还款压力较大，但总利息较少。'
    ],
    tipsTitle: '使用建议',
    tipsList: [
      '对比两种还款方式的总利息差异，选择适合自己的方案',
      '等额本息总利息更高，但每月还款额固定，便于预算规划',
      '等额本金总利息更少，但前期月供较高，需要确保还款能力',
      '贷款前建议了解各银行最新利率政策，选择最优利率'
    ]
  },
  blog: {
    title: '技术博客',
    subtitle: '实用技术教程与深度知识分享',
    readMore: '阅读全文',
    backToList: '返回文章列表',
    notFound: '文章不存在',
    authorName: '月升工具网编辑部',
    authorBio: '致力于分享实用的技术知识和工具使用技巧，帮助用户提升工作效率。',
    articles: {
      'json-guide': {
        title: 'JSON 完全指南：从入门到精通的实用教程',
        category: '开发技术',
        date: '2026-02-10',
        readTime: '约 8 分钟',
        summary: 'JSON 是现代 Web 开发中最重要的数据格式之一。本文将从 JSON 的基础概念讲起，深入探讨其语法规则、常见错误、最佳实践，以及在实际项目中的应用技巧。',
        sections: [
          {
            heading: 'JSON 的诞生背景',
            text: '2001 年，道格拉斯·克罗克福德（Douglas Crockford）提出了 JSON（JavaScript Object Notation）格式。在此之前，Web 应用主要使用 XML 来传输数据，但 XML 语法冗长、解析复杂。JSON 以其简洁的语法和与 JavaScript 的天然亲和性，迅速成为 Web API 和配置文件的首选格式。如今，几乎所有主流编程语言都内置了 JSON 解析库。'
          },
          {
            heading: 'JSON 的六种数据类型',
            text: 'JSON 支持六种数据类型，理解它们是正确使用 JSON 的基础：',
            list: [
              '字符串（String）：必须使用双引号包裹，如 "hello"。不能使用单引号，这是初学者最常犯的错误',
              '数字（Number）：支持整数和浮点数，如 42、3.14、-10。不支持 NaN 和 Infinity',
              '布尔值（Boolean）：只有 true 和 false 两个值，必须小写',
              '空值（Null）：表示空值，必须写为 null（小写）',
              '对象（Object）：使用花括号 {} 包裹的键值对集合，键必须是字符串',
              '数组（Array）：使用方括号 [] 包裹的有序值列表，元素可以是任意类型'
            ]
          },
          {
            heading: 'JSON 格式化的重要性',
            text: '在实际开发中，JSON 数据通常是压缩的（没有空格和换行），这虽然减小了传输体积，但极难阅读和调试。格式化（Pretty Print）可以将压缩的 JSON 转换为带有缩进和换行的可读格式。好的格式化工具还能验证 JSON 的语法正确性，帮助开发者快速定位错误。我们的 JSON 格式化工具就提供了一键格式化和语法验证功能。'
          },
          {
            heading: '常见的 JSON 语法错误及解决方法',
            list: [
              '尾随逗号：最后一个元素后面不能有逗号。{"a":1, "b":2,} 是错误的',
              '单引号问题：JSON 标准只允许双引号。{\'name\': \'test\'} 是错误的',
              '注释问题：JSON 标准不支持注释。如需注释，可以考虑使用 JSON5 或 JSONC 格式',
              '未转义的特殊字符：字符串中的双引号、反斜杠、换行符等需要转义',
              '键名未加引号：所有键名必须用双引号包裹，{name: "test"} 是错误的'
            ]
          },
          {
            heading: 'JSON 在前后端交互中的最佳实践',
            text: '在前后端分离的架构中，JSON 是最常用的数据交换格式。以下是一些实践建议：',
            list: [
              '统一响应格式：建议使用 {code, message, data} 三层结构，方便前端统一处理',
              '日期格式标准化：推荐使用 ISO 8601 格式（如 2026-02-10T08:30:00Z），避免时区混乱',
              '字段命名规范：建议使用 camelCase（如 userName）或 snake_case（如 user_name），保持一致',
              '分页数据结构：列表接口建议返回 {list, total, page, pageSize} 便于前端分页展示',
              '敏感数据过滤：后端返回 JSON 时应过滤密码、密钥等敏感字段'
            ]
          },
          {
            heading: '从 JSON 到 JSON Schema',
            text: 'JSON Schema 是一种用于描述 JSON 数据结构的规范。它可以定义 JSON 对象中每个字段的类型、是否必填、取值范围等约束条件。在大型项目中，使用 JSON Schema 可以实现接口文档自动生成、请求参数自动验证、IDE 智能提示等功能，大幅提升开发效率和代码质量。'
          }
        ]
      },
      'timestamp-explained': {
        title: '时间戳详解：程序员必须掌握的时间处理知识',
        category: '开发技术',
        date: '2026-02-08',
        readTime: '约 7 分钟',
        summary: '时间处理是软件开发中常见但容易出错的领域。本文深入讲解 Unix 时间戳的工作原理、时区问题的正确处理方式，以及不同编程语言中的时间操作方法。',
        sections: [
          {
            heading: '为什么时间处理这么复杂？',
            text: '看似简单的时间概念，在计算机中却充满了复杂性。不同时区的人看到不同的时间、夏令时让时钟前后跳转、闰秒让一分钟偶尔有 61 秒、不同国家的日历格式各不相同。这些因素叠加在一起，使得时间处理成为编程中最容易出 bug 的领域之一。Unix 时间戳的出现，就是为了简化这些复杂性。'
          },
          {
            heading: 'Unix 时间戳的工作原理',
            text: 'Unix 时间戳是一个简单的整数，表示从 1970 年 1 月 1 日 00:00:00 UTC 到当前时刻经过的秒数。它的核心优势在于：不受时区影响。无论你在北京（UTC+8）还是纽约（UTC-5），同一时刻的时间戳都是相同的数字。这使得它成为跨时区系统中存储和传输时间信息的理想方式。'
          },
          {
            heading: '秒级与毫秒级时间戳的选择',
            text: '秒级时间戳（10 位数字）足以满足大多数场景的需求，如日志记录、用户注册时间等。毫秒级时间戳（13 位数字）适用于需要更高精度的场景，如金融交易、性能监控、动画帧计时等。JavaScript 的 Date.now() 默认返回毫秒级时间戳，而 Python 的 time.time() 返回的是带小数的秒级时间戳。在前后端交互时，务必统一时间戳的精度。'
          },
          {
            heading: '时区处理的正确姿势',
            list: [
              '存储原则：数据库中始终存储 UTC 时间或时间戳，不要存储本地时间',
              '显示原则：在前端根据用户所在时区转换为本地时间显示',
              '传输原则：API 接口使用 UTC 时间或时间戳，避免传输本地时间',
              '日志原则：服务器日志使用 UTC 时间，方便跨时区排查问题',
              '配置时区：允许用户在系统中设置自己的时区偏好'
            ]
          },
          {
            heading: '2038 年问题与应对',
            text: '32 位系统使用有符号 32 位整数存储时间戳，最大值为 2147483647，对应 2038 年 1 月 19 日 03:14:07 UTC。超过这个时间点，32 位系统的时间戳将溢出变为负数。虽然大多数现代系统已经迁移到 64 位，但一些嵌入式系统和老旧软件仍然面临风险。如果你在开发长期运行的系统，确保使用 64 位时间戳。'
          },
          {
            heading: '实用的时间处理工具推荐',
            text: '在实际开发中，直接操作时间戳虽然简单但容易出错。推荐使用成熟的时间处理库：JavaScript 推荐使用 day.js（轻量）或 date-fns（函数式）；Python 推荐使用内置的 datetime 模块配合 pytz 时区库；Java 推荐使用 java.time 包（Java 8+）。这些库封装了时区转换、格式化、日期计算等常用操作，能大幅减少时间处理相关的 bug。'
          }
        ]
      },
      'mortgage-tips': {
        title: '房贷计算全攻略：如何选择最适合自己的还款方案',
        category: '生活理财',
        date: '2026-02-05',
        readTime: '约 10 分钟',
        summary: '买房是大多数家庭最重要的经济决策之一。本文从实际出发，详细分析等额本息和等额本金两种还款方式的优劣，并给出不同收入水平下的房贷规划建议。',
        sections: [
          {
            heading: '房贷基础知识',
            text: '住房贷款是银行向购房者提供的以所购房产作为抵押的贷款。在中国，目前有三种主要的房贷类型：商业贷款、公积金贷款和组合贷款。商业贷款利率较高但审批灵活；公积金贷款利率低但额度有限（通常不超过 120 万元）；组合贷款则结合了两者的优势。选择合适的贷款类型是控制房贷成本的第一步。'
          },
          {
            heading: '等额本息 vs 等额本金：深度对比',
            text: '等额本息每月还款额固定，但前期以还利息为主，本金偿还较少。等额本金每月偿还固定的本金，利息逐月递减，因此月供逐渐降低。以贷款 100 万元、利率 3.45%、期限 30 年为例：等额本息每月还款约 4,462 元，总利息约 60.6 万元；等额本金首月还款约 5,653 元，末月约 2,800 元，总利息约 51.8 万元。等额本金可以节省约 8.8 万元利息。'
          },
          {
            heading: '不同收入水平的还贷建议',
            list: [
              '月收入 1-2 万元：建议选择等额本息，月供控制在 5000-8000 元，保留足够生活资金',
              '月收入 2-3 万元：两种方式均可，如果存款充足可选等额本金节省利息',
              '月收入 3 万元以上：建议选择等额本金，前期虽然月供高，但总利息明显减少',
              '双职工家庭：以两人总收入的 30% 作为月供上限，确保一人失业时仍可承受',
              '有投资能力的家庭：如果投资年化收益稳定超过房贷利率，可以选择等额本息，用多余资金投资'
            ]
          },
          {
            heading: '提前还款的策略与时机',
            text: '提前还款是很多购房者都会考虑的问题。但是否应该提前还款，需要综合考虑多个因素。如果你的房贷利率较高（超过 4%），且手头有闲置资金、没有更好的投资渠道，那么提前还款是合理的选择。但如果房贷利率较低（3.5% 以下），且有稳定的投资渠道可以获得更高收益，那么保留贷款、用资金投资可能更划算。提前还款的最佳时机是贷款的前 1/3 期间，因为这时候利息占比最高。'
          },
          {
            heading: 'LPR 利率变动对房贷的影响',
            text: 'LPR（贷款市场报价利率）是中国房贷利率的基准。自 2019 年起，新增房贷利率全部以 LPR 为基准加点确定。每月 20 日，全国银行间同业拆借中心会公布最新 LPR 利率。对于浮动利率房贷，每年的利率重定价日（通常为 1 月 1 日）会根据最新 LPR 调整利率。因此，关注 LPR 走势对于评估未来还款压力非常重要。'
          },
          {
            heading: '房贷申请的注意事项',
            list: [
              '提前半年维护好征信记录，避免逾期和频繁查询',
              '准备好收入证明，月收入至少是月供的 2 倍以上',
              '评估自己的公积金缴存基数，确定公积金贷款额度',
              '了解不同银行的利率加点政策，货比三家',
              '预留 3-6 个月月供作为应急资金，防止断供风险'
            ]
          }
        ]
      },
      'markdown-writing': {
        title: 'Markdown 写作指南：让你的文字排版更优雅',
        category: '效率工具',
        date: '2026-02-01',
        readTime: '约 6 分钟',
        summary: 'Markdown 是技术人员和内容创作者的必备写作工具。本文将教你如何用 Markdown 高效写作，包括常用语法、进阶技巧和最佳实践。',
        sections: [
          {
            heading: '为什么你应该学习 Markdown',
            text: '在数字化写作时代，我们经常需要在不同平台之间切换：写博客、做笔记、写文档、发帖子。每个平台的排版方式都不同，从 Word 的所见即所得，到 HTML 的标签语法。Markdown 提供了一种统一的解决方案：用简单的纯文本标记来表示格式。学会 Markdown，你可以在 GitHub、Notion、语雀、Obsidian、微信公众号编辑器等几乎所有主流平台上高效写作。'
          },
          {
            heading: '5 分钟掌握 Markdown 核心语法',
            text: 'Markdown 的核心语法非常简洁，只需要记住以下几个关键标记：',
            list: [
              '标题：使用 # 号，一个 # 是一级标题，两个 ## 是二级标题，最多六级',
              '加粗：使用 **加粗文字** 包裹',
              '斜体：使用 *斜体文字* 包裹',
              '链接：[链接文字](网址) 的格式',
              '图片：![描述文字](图片地址) 的格式',
              '列表：无序列表用 - 开头，有序列表用 1. 2. 3. 开头',
              '引用：使用 > 开头',
              '代码：行内代码用反引号包裹，代码块用三个反引号包裹'
            ]
          },
          {
            heading: 'Markdown 进阶技巧',
            list: [
              '表格：使用 | 分隔列，用 --- 分隔表头和内容，可以用 :--- 左对齐、:---: 居中、---: 右对齐',
              '任务列表：使用 - [ ] 创建未完成任务，- [x] 创建已完成任务',
              '脚注：使用 [^1] 添加脚注引用，在文末用 [^1]: 内容 定义脚注内容',
              '删除线：使用 ~~删除文字~~ 包裹',
              '分割线：使用三个或更多的 --- 或 *** 创建',
              '嵌套列表：在列表项下方缩进两个空格即可创建子列表'
            ]
          },
          {
            heading: 'Markdown 写作的最佳实践',
            text: '好的 Markdown 文档不仅仅是正确使用语法，还要注意文档的结构和可读性：',
            list: [
              '使用层级合理的标题结构，不要跳级（从 H1 直接到 H3）',
              '段落之间留空行，保持视觉上的清晰分隔',
              '代码块始终指定语言类型，以获得语法高亮',
              '图片添加描述性的 alt 文本，提升可访问性',
              '长文档使用目录（TOC），帮助读者快速定位',
              '保持文件名简洁有意义，使用连字符分隔单词'
            ]
          },
          {
            heading: '推荐的 Markdown 编辑器',
            text: '不同的使用场景有不同的最佳编辑器选择。轻量级笔记推荐使用 Obsidian，它支持双向链接和知识图谱；技术文档推荐使用 VS Code + Markdown 插件，方便与代码一起管理；在线协作推荐使用 HackMD 或 Notion；如果你需要一个快速、无需安装的编辑器，我们的在线 Markdown 编辑器就是一个很好的选择，支持实时预览、一键复制 HTML。'
          }
        ]
      },
      'image-optimization': {
        title: '网页图片优化完全手册：提升网站性能的关键技巧',
        category: '前端技术',
        date: '2026-01-28',
        readTime: '约 9 分钟',
        summary: '图片通常占据网页总大小的 60% 以上。本文详细介绍各种图片格式的特点、压缩策略、懒加载技术，以及现代 Web 中的图片最佳实践。',
        sections: [
          {
            heading: '图片为何是网页性能的最大瓶颈',
            text: '根据 HTTP Archive 的数据，图片平均占据网页总大小的 50%-65%。一个未优化的网页可能包含数十张高分辨率图片，总大小达到数兆字节。对于移动用户和网络条件较差的用户，这意味着极长的加载时间和极高的流量消耗。Google 的研究表明，页面加载时间每增加 1 秒，跳出率就增加 32%。因此，图片优化是提升网站性能最有效的手段之一。'
          },
          {
            heading: '五大图片格式深度解析',
            list: [
              'JPEG/JPG：有损压缩格式，适合照片和色彩丰富的图片。质量设置在 75-85% 时，文件大小和视觉质量之间有最佳平衡。不支持透明背景',
              'PNG：无损压缩格式，支持透明背景。PNG-8 最多 256 色适合简单图形，PNG-24 支持 1600 万色适合需要透明的复杂图片。文件通常比 JPEG 大',
              'WebP：Google 推出的现代格式，同质量下比 JPEG 小 25-34%，比 PNG 小 26%。同时支持有损和无损压缩、透明背景和动画。目前主流浏览器均已支持',
              'GIF：支持动画和透明，但仅限 256 色。适合简单的动画图标，不适合照片。对于复杂动画，建议使用 WebP 或视频格式替代',
              'SVG：矢量图形格式，使用 XML 描述图形，可以无限缩放不失真。非常适合图标、Logo、简单插图。文件极小，且可以通过 CSS 修改样式'
            ]
          },
          {
            heading: '图片压缩的科学方法',
            text: '图片压缩分为有损压缩和无损压缩。有损压缩会丢弃一些人眼不易察觉的细节来减小文件大小，JPEG 是典型的有损格式。无损压缩则通过更高效的编码方式减小文件大小，不丢失任何信息，PNG 采用的就是无损压缩。在实际使用中，建议对照片使用有损压缩（质量 75-85%），对需要精确还原的图形使用无损压缩。'
          },
          {
            heading: '响应式图片与懒加载',
            text: '现代 Web 开发中，响应式图片和懒加载是两个关键优化技术。响应式图片使用 HTML 的 srcset 属性，让浏览器根据设备屏幕大小和像素密度自动选择合适分辨率的图片，避免在手机上加载桌面端的高分辨率图片。懒加载（Lazy Loading）则是只在图片进入可视区域时才开始加载，大幅减少初始页面加载时间。现代浏览器原生支持 loading="lazy" 属性。'
          },
          {
            heading: '图片 CDN 的优势',
            list: [
              '自动格式转换：根据浏览器支持情况自动提供 WebP 或 AVIF 格式',
              '动态调整尺寸：通过 URL 参数指定图片尺寸，无需手动裁剪',
              '全球加速：将图片缓存到全球各地的边缘节点，就近提供服务',
              '智能压缩：根据网络质量自动调整压缩级别',
              '流量节省：通常可以减少 40%-70% 的图片流量'
            ]
          },
          {
            heading: '实际操作建议',
            text: '我们的图片处理工具提供了本地化的图片压缩功能，所有处理都在浏览器中完成，不会上传任何数据到服务器。你可以调整图片质量、缩放比例，应用滤镜效果，并实时预览压缩后的效果。建议在上传图片到网站之前，先使用工具将图片压缩到合理的大小，通常 Web 展示用的图片控制在 100-200KB 以内是一个好的目标。'
          }
        ]
      }
    }
  },
  base64: {
    title: 'Base64 编解码',
    subtitle: '在线 Base64 编码与解码工具，支持中文和特殊字符处理',
    inputLabel: '输入文本',
    outputLabel: '输出结果',
    inputPlaceholder: '请输入需要编码或解码的文本...',
    outputPlaceholder: '结果将显示在这里...',
    encode: '编码',
    decode: '解码',
    swap: '交换输入输出',
    encodeSuccess: 'Base64 编码成功！',
    encodeError: '编码失败，请检查输入内容',
    decodeSuccess: 'Base64 解码成功！',
    decodeError: '解码失败，请确认输入的是有效的 Base64 字符串',
    whatIs: '什么是 Base64？',
    whatIsDesc: 'Base64 是一种基于 64 个可打印字符来表示二进制数据的编码方式。它常用于在需要以文本形式处理二进制数据的场景中，如电子邮件附件编码、在 URL 中嵌入数据、在 CSS 中内嵌小图片（Data URI）等。Base64 编码后的数据体积约增大 33%，但确保数据在传输过程中不会被错误处理。所有编解码操作均在浏览器本地完成，保护您的数据安全。',
    useCasesTitle: '常见应用场景',
    useCases: [
      '邮件附件编码：MIME 协议使用 Base64 对邮件附件进行编码',
      'Data URI：在 HTML/CSS 中直接嵌入小图片或字体文件',
      'API 传输：在 JSON 或 URL 中安全传递二进制数据',
      'JWT Token：JSON Web Token 使用 Base64 编码其头部和载荷部分',
      '数据存储：将二进制数据以文本形式存储在数据库或配置文件中'
    ],
    tipsTitle: '使用技巧',
    tips: [
      '本工具支持中文编码，内部使用 UTF-8 编码处理',
      'Base64 不是加密，不能用于保护敏感数据',
      '编码后的字符串只包含 A-Z、a-z、0-9、+、/ 和 = 字符',
      '如果解码失败，请检查输入是否为合法的 Base64 字符串'
    ]
  },
  urlCodec: {
    title: 'URL 编解码',
    subtitle: '在线 URL 编码与解码工具，支持 encodeURI 和 encodeURIComponent',
    inputLabel: '输入文本',
    outputLabel: '输出结果',
    inputPlaceholder: '请输入需要编码或解码的 URL 或文本...',
    outputPlaceholder: '结果将显示在这里...',
    encode: 'encodeURI',
    decode: '解码',
    encodeComponent: 'encodeURIComponent',
    swap: '交换输入输出',
    encodeSuccess: '编码成功！',
    decodeSuccess: '解码成功！',
    decodeError: '解码失败，请检查输入内容',
    error: '编码出错',
    whatIs: '什么是 URL 编码？',
    whatIsDesc: 'URL 编码（也叫百分号编码）是一种将特殊字符转换为 %XX 形式的编码方式，使其可以安全地在 URL 中传输。URL 规范只允许使用 ASCII 字符集中的一部分字符，中文、空格、特殊符号等字符必须经过编码后才能出现在 URL 中。JavaScript 提供了 encodeURI 和 encodeURIComponent 两个函数，它们的编码范围不同。所有操作均在浏览器本地完成。',
    useCasesTitle: '常见应用场景',
    useCases: [
      'URL 参数传递：将中文、空格等特殊字符编码后放入 URL 参数中',
      'API 请求：确保 GET 请求中的查询参数格式正确',
      '表单提交：浏览器会自动对表单数据进行 URL 编码',
      '前端路由：对动态路由参数中的特殊字符进行编码',
      '链接分享：确保包含特殊字符的链接可以被正确打开'
    ],
    tipsTitle: '使用技巧',
    tips: [
      'encodeURI：编码整个 URL，保留 :/?#[]@!$&\'()*+,;= 等 URL 功能字符',
      'encodeURIComponent：编码 URL 中的参数部分，会编码除 -_.!~*\'() 外的所有特殊字符',
      '一般传递参数值时使用 encodeURIComponent，编码完整 URL 时使用 encodeURI',
      '如果解码出现乱码，可能是编码格式不匹配，请检查原始编码方式'
    ]
  },
  hashTool: {
    title: 'MD5/SHA 哈希计算',
    subtitle: '在线计算文本的 MD5、SHA-1、SHA-256、SHA-384、SHA-512 哈希值',
    inputLabel: '输入文本',
    inputPlaceholder: '请输入需要计算哈希值的文本...',
    outputCase: '输出格式',
    upper: '大写',
    lower: '小写',
    whatIs: '什么是哈希算法？',
    whatIsDesc: '哈希算法（Hash Algorithm）是一种将任意长度的输入数据转换为固定长度输出（哈希值/摘要）的算法。好的哈希算法具有单向性（无法从哈希值反推原始数据）、确定性（相同输入总是产生相同输出）和抗碰撞性（很难找到两个不同输入产生相同输出）。哈希算法广泛用于数据完整性校验、密码存储、数字签名等场景。本工具所有计算均在浏览器本地完成。',
    algosTitle: '支持的哈希算法',
    algos: [
      'MD5：128 位输出，计算速度快，但已不推荐用于安全场景，适合文件校验',
      'SHA-1：160 位输出，已被证明不够安全，正逐步被淘汰',
      'SHA-256：256 位输出，目前最常用的安全哈希算法，比特币使用的核心算法',
      'SHA-384：384 位输出，SHA-256 的加长版，安全性更高',
      'SHA-512：512 位输出，安全性最高，适合对安全要求极高的场景'
    ],
    useCasesTitle: '常见应用场景',
    useCases: [
      '文件完整性校验：对比下载文件的哈希值与官方提供的值，验证文件未被篡改',
      '密码存储：将用户密码的哈希值存入数据库，而非明文密码',
      '数据去重：通过比较哈希值快速判断两段数据是否相同',
      '数字签名：对文档或代码生成哈希值，结合非对称加密实现数字签名',
      '区块链：比特币等区块链技术的核心基础之一'
    ]
  },
  unicodeConverter: {
    title: 'Unicode 编码转换',
    subtitle: '在 Unicode、十六进制、HTML 实体和 UTF-8 之间互相转换',
    inputLabel: '输入文本',
    outputLabel: '转换结果',
    inputPlaceholder: '请输入需要转换的文本或编码...',
    outputPlaceholder: '转换结果将显示在这里...',
    convert: '转换 →',
    reverse: '反向转换',
    mode: {
      unicode: 'Unicode (\\uXXXX)',
      hex: '十六进制 (\\xXX)',
      htmlEntity: 'HTML 实体 (&#NNN;)',
      utf8Hex: 'UTF-8 十六进制'
    },
    whatIs: '什么是 Unicode？',
    whatIsDesc: 'Unicode 是一种国际字符编码标准，旨在为世界上所有的文字和符号提供统一的编码。Unicode 定义了超过 14 万个字符，覆盖了几乎所有的人类语言。在编程中，经常需要在不同编码格式之间转换，例如将中文转换为 \\uXXXX 格式在 JSON 中传输，或将特殊字符转为 HTML 实体在网页中显示。本工具支持多种编码格式的互转，所有操作在浏览器本地完成。',
    useCasesTitle: '常见应用场景',
    useCases: [
      'JSON 编码：在 JSON 中使用 \\uXXXX 格式表示中文和特殊字符',
      'HTML 编码：使用 HTML 实体避免特殊字符被浏览器错误解析',
      'JavaScript 转义：在 JS 代码中使用 \\xXX 或 \\uXXXX 表示特殊字符',
      '国际化开发：处理多语言文本的编码转换需求',
      '数据调试：查看字符的底层编码表示，排查编码问题'
    ]
  },
  morseCode: {
    title: '摩斯电码转换',
    subtitle: '文本与摩斯电码在线互转，支持中文字符和音频播放',
    modeLabel: '编码模式',
    modeBasic: '基础模式',
    modeChinese: '中文模式',
    modeBasicHint: '仅支持英文字母、数字和常用标点',
    modeChineseHint: '支持中英文混合，中文通过 Unicode 编码转换',
    textLabel: '普通文本',
    morseLabel: '摩斯电码',
    textPlaceholder: '请输入英文文本...',
    textPlaceholderCn: '请输入中英文文本（如：你好 World）...',
    morsePlaceholder: '摩斯电码将显示在这里（用空格分隔字母，用 / 分隔单词）...',
    encode: '转为摩斯电码',
    decode: '转为文本',
    play: '播放',
    chartTitle: '摩斯电码对照表',
    encodeSuccess: '已转换为摩斯电码！',
    decodeSuccess: '已转换为文本！',
    cnEncodingTitle: '中文编码原理',
    cnEncodingDesc: '中文模式下，每个中文字符会先转换为 Unicode 码点的十六进制表示（4位），然后将每个十六进制字符编码为对应的摩斯电码，用方括号 [ ] 包裹表示一个完整的中文字符。英文字母和数字仍按标准摩斯电码编码。示例：',
    whatIs: '什么是摩斯电码？',
    whatIsDesc: '摩斯电码（Morse Code）是由美国发明家塞缪尔·摩斯在 1836 年发明的一种时通时断的信号编码。它用不同长短的信号（点 · 和划 -）组合来表示字母、数字和标点符号。摩斯电码是最早的数字化通信形式之一，曾广泛用于电报通信。虽然现代通信技术已经取代了电报，但摩斯电码仍被用于航空、航海、业余无线电和紧急求救（SOS：··· --- ···）等场景。',
    useCasesTitle: '常见应用场景',
    useCases: [
      '学习教育：了解早期通信技术和编码原理',
      '紧急求救：SOS（··· --- ···）是国际通用的求救信号',
      '业余无线电：全球业余无线电爱好者仍在使用摩斯电码通信',
      '密码学入门：摩斯电码是理解编码和加密的良好起点',
      '文化趣味：用摩斯电码制作特别的消息、饰品或纹身设计'
    ]
  },
  passwordGen: {
    title: '随机密码生成器',
    subtitle: '生成安全的随机密码，支持自定义规则和批量生成',
    placeholder: '点击生成按钮创建密码',
    length: '密码长度',
    uppercase: '大写字母',
    lowercase: '小写字母',
    numbers: '数字',
    symbols: '特殊符号',
    excludeAmbiguous: '排除易混淆字符 (0Oo1Il)',
    generate: '生成密码',
    strengthLabel: '密码强度',
    weak: '弱',
    medium: '中',
    strong: '强',
    batchTitle: '批量生成',
    batchCount: '生成数量',
    batchGenerate: '批量生成',
    whatIs: '为什么需要强密码？',
    whatIsDesc: '弱密码是网络安全最大的威胁之一。常见密码如 "123456"、"password" 等可以在几秒内被暴力破解。安全的密码应该足够长（至少 12 位）、包含多种字符类型（大小写字母、数字、符号），并且每个账号使用不同的密码。本工具使用浏览器原生的加密安全随机数生成器（crypto.getRandomValues），确保生成的密码具有真正的随机性。所有密码生成均在浏览器本地完成，不会被发送到任何服务器。',
    tipsTitle: '密码安全建议',
    tips: [
      '密码长度至少 12 位，16 位以上更安全',
      '混合使用大写字母、小写字母、数字和特殊符号',
      '每个重要账号使用不同的密码',
      '使用密码管理器（如 1Password、Bitwarden）存储密码',
      '启用双因素认证（2FA）为账号增加额外保护',
      '避免使用个人信息（生日、名字等）作为密码的一部分'
    ]
  },
  uuidGen: {
    title: 'UUID/GUID 生成器',
    subtitle: '在线生成通用唯一识别码，支持 v1 和 v4 版本',
    version: 'UUID 版本',
    caseLabel: '大小写',
    lower: '小写',
    upper: '大写',
    withBraces: '添加花括号 {}',
    noDashes: '去除横杠 -',
    batchTitle: '批量生成',
    batchCount: '生成数量',
    batchGenerate: '批量生成',
    whatIs: '什么是 UUID？',
    whatIsDesc: 'UUID（Universally Unique Identifier，通用唯一识别码）是一种 128 位的标识符，设计上可以保证在全球范围内的唯一性。UUID 的格式为 xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx（32 个十六进制字符用 4 个连字符分隔）。UUID 最常用的版本是 v4（基于随机数）和 v1（基于时间戳和 MAC 地址）。UUID 广泛用于数据库主键、分布式系统、会话标识等需要唯一标识符的场景。',
    useCasesTitle: '常见应用场景',
    useCases: [
      '数据库主键：避免自增 ID 带来的安全隐患和分布式冲突',
      '分布式系统：在多个服务节点间生成不冲突的唯一标识',
      '会话管理：生成用户会话 ID，确保每个会话唯一',
      'API 请求追踪：为每个请求生成唯一 ID，便于日志追踪',
      '文件命名：上传文件时使用 UUID 命名，避免文件名冲突'
    ],
    tipsTitle: '使用技巧',
    tips: [
      'UUID v4 基于随机数，适合大多数场景，简单安全',
      'UUID v1 包含时间信息，可以按时间排序，适合需要时序的场景',
      '数据库中存储 UUID 可以去除横杠以节省空间',
      'UUID 的碰撞概率极低（约 2^122 分之一），实际使用中可以认为不会重复',
      '如需更短的唯一 ID，可以考虑使用 NanoID 等替代方案'
    ]
  }
}
